/* node环境的兼容层 */
((function () {
  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    global.fakeWindow = {
      sessionStorage: {
        getItem: function getItem() {},
        setItem: function setItem() {}
      },
      addEventListener: function addEventListener() {},
      location: {
        href: '',
        host: ''
      },
      __ikea_jssdk__: {}
    };
    global.location = global.fakeWindow.location(global).document = {
      cookie: '',
      title: '',
      createElement: function createElement() {
        return {
          style: {}
        };
      },
      body: {
        appendChild: function appendChild() {}
      }
    };

    global.fetch = function () {
      return Promise.resolve({
        json: function json() {
          return Promise.resolve({
            data: ''
          });
        },
        ok: true
      });
    };

    global.HTMLElement = function () {};

    global.customElements = {
      get: function get() {},
      define: function define() {}
    };
  } else {
    window.fakeWindow = window;
  }
}))();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest$1();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * @description 用于统一处理信息返回
 * @param type api调用的成功/失败
 * @param value api返回值
 * @param msg api调用信息
 */

/**
 * @description 业务逻辑message
 */
var message = function message(msg, type, value) {
  if (value !== undefined) return Promise.resolve({
    msg: msg,
    type: type,
    value: value
  });
  return Promise.resolve({
    msg: msg,
    type: type
  });
};
var success = function success(msg, value) {
  return message(msg, 'success', value);
};
var apiInvokeSuccess = function apiInvokeSuccess(api, value) {
  return success("API(".concat(api, ") success"), value);
};
var fail = function fail(api, msg) {
  msg = "API(".concat(api, ") fail: ").concat(msg);
  console.warn(msg);
  return message(msg, 'fail');
};

function parseVersion(version) {
  var match = version.match(/^(\d+)\.(\d+)\.(\d+)$/);

  if (!match) {
    throw new Error("Invalid version format");
  }

  return [parseInt(match[1]), parseInt(match[2]), parseInt(match[3])];
}

function compareVersions(v1, v2) {
  for (var i = 0; i < 3; i++) {
    if (v1[i] > v2[i]) return 1;
    if (v1[i] < v2[i]) return -1;
  }

  return 0;
}

function parseRange(rangeStr) {
  var match = rangeStr.match(/^(>=|<=|>|<|=)?(\d+\.\d+\.\d+)$/);

  if (!match) {
    throw new Error("Invalid range format");
  }

  var operator = match[1];
  if (!operator) operator = '=';
  var version = parseVersion(match[2]);
  return {
    operator: operator,
    version: version
  };
}

function satisfies(version, rangeStr) {
  var versionParsed = parseVersion(version);

  var _parseRange = parseRange(rangeStr),
      operator = _parseRange.operator,
      rangeVersion = _parseRange.version;

  var comparison = compareVersions(versionParsed, rangeVersion);

  switch (operator) {
    case '>=':
      return comparison >= 0;

    case '<=':
      return comparison <= 0;

    case '>':
      return comparison > 0;

    case '<':
      return comparison < 0;

    case '=':
      return comparison === 0;

    default:
      throw new Error("Invalid operator");
  }
}

/* debug开关 */

var debug = false;
var setDebug = function setDebug(isDebug) {
  debug = isDebug;
};
var isDebug = function isDebug() {
  return debug;
};
/**
 * env环境
 * 将来逐步代替debug
 */

var env = null;
var setEnv = function setEnv(e) {
  env = e;
};
var getEnv = function getEnv() {
  if (env === null) {
    if (isDebug()) return 'qa';
    if (!isDebug()) return 'prod';
  }

  return env;
};
/* 处理接口401错误 */

var unauthorizationHandler = null;
var setUnauthorizationHandler = function setUnauthorizationHandler(handler) {
  unauthorizationHandler = handler;
};
var getUnauthorizationHandler = function getUnauthorizationHandler() {
  return unauthorizationHandler;
};
/* refer相关 */

var refer = null;
var setRefer = function setRefer(_refer) {
  refer = _refer;
};
var getRefer = function getRefer() {
  return refer;
};
/*  */

/* prerender */

var prerender = false;
var setPrerender = function setPrerender(val) {
  prerender = val;
};
var getPrerender = function getPrerender() {
  return prerender;
};
/* 后端埋点相关的全局参数 */

var backendTrackingParams = {
  pageType: 'h5',
  pageId: fakeWindow.location.origin + fakeWindow.location.pathname,
  pageName: document.title
};
var setBackendTrackingParams = function setBackendTrackingParams() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Object.keys(val).forEach(function (key) {
    backendTrackingParams[key] = val[key];
  });
};
var getBackendTrackingParams = function getBackendTrackingParams() {
  return backendTrackingParams;
};
/* gio链接 */

var gioLinkMaping = {
  h5: 'https://assets.giocdn.com/2.1/gio.js',
  miniprogram: 'https://assets.giocdn.com/2.0/gio-wxwv.js'
};
/* gio config */

var gioConfig = {
  web: {
    projectId: '89f223324127f5da'
  },
  universal: {
    projectId: '998955b721e66f35'
  },
  smp: {
    projectId: '998955b721e66f35',
    appId: {
      shoppableMiniprogram: 'wxd47892129d2fa9e9'
    }
  }
};
/* 是否是localhost */

var isLocal = fakeWindow.location.host.startsWith("127.0.0.1") || fakeWindow.location.host.startsWith("localhost");
/* 官网地址 */

var webHostMapping = {
  prod: 'https://www.ikea.cn',
  qa: 'https://www-qa.web.ikea.cn',
  ppe: 'https://www.pp01.test.ikea.cn',
  uat: 'https://www-uat.web.ikea.cn',
  dev: 'https://dev-web.ingka-dt.cn',
  ctem: 'https://ctem-web.ingka-dt.cn'
};
var webHost = function webHost() {
  var webOrigin = getCookie('ikeacn_origin');
  return webOrigin || webHostMapping[getEnv()] || webHostMapping.prod;
};
/* 返回相应接口 */

var mbffHostMapping = {
  prod: 'https://srv.app.ikea.cn',
  qa: 'https://srv-qa.app.ikea.cn',
  dev: 'https://srv-dev.app.ikea.cn',
  uat: 'https://srv-ppe.app.ikea.cn',
  ctem: 'https://api-ctem-app.ingka-dt.cn',
  ppe: 'https://srv-ppe.app.ikea.cn'
};
var getMBFFHost = function getMBFFHost() {
  return mbffHostMapping[getEnv()] || mbffHostMapping.prod;
};
/* 返回相应资源地址 */

var resHostMapping = {
  prod: 'https://res.app.ikea.cn',
  qa: 'https://res-qa.app.ikea.cn',
  dev: 'https://res-dev.app.ikea.cn',
  uat: 'https://res-uat.app.ikea.cn',
  ctem: 'https://res-ctem-app.ingka-dt.cn',

  /* 以下环境缺失 */
  ppe: 'https://res-qa.app.ikea.cn'
};
var getResHost = function getResHost() {
  return resHostMapping[getEnv()] || resHostMapping.prod;
};
/* 平台相关数据 */

var getCurrentPlatform$1 = function getCurrentPlatform() {
  return {
    platform: getPlatform(),
    clientVersion: getClientVersion(),
    osVersion: getOsVersion$1()
  };
};
/* 微信apiList */

var API_LIST = ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareQZone', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'];
/* 微信openTagList */

var OPEN_TAG_LIST = ['wx-open-launch-weapp', 'wx-open-launch-app'];
/* 返回相应资源地址 */

var routerConfigUrlMapping = {
  prod: 'https://res.app.ikea.cn/modules/router-config.json',
  qa: 'https://res-qa.app.ikea.cn/modules/router-config.json',
  dev: 'https://res-qa.app.ikea.cn/modules/router-config.json',
  uat: 'https://res-qa.app.ikea.cn/modules/router-config.json',
  ctem: 'https://res-qa.app.ikea.cn/modules/router-config.json',
  ppe: 'https://res-qa.app.ikea.cn/modules/router-config.json'
};
var getRouterConfigUrl = function getRouterConfigUrl() {
  return routerConfigUrlMapping[getEnv()] || routerConfigUrlMapping.prod;
};
/* clickhouse keys */

var clickKeys = {
  prod: 'mpjYFUbwVuTYG8ozVWqKrk8QABjwqw9Z',
  qa: 'fe1164dcc2e55b6b92995e4fc3b353c6',
  dev: 'fe1164dcc2e55b6b92995e4fc3b353c6',
  uat: 'fe1164dcc2e55b6b92995e4fc3b353c6',
  ctem: 'fe1164dcc2e55b6b92995e4fc3b353c6',
  ppe: 'fe1164dcc2e55b6b92995e4fc3b353c6'
};
var getClickhouseKey = function getClickhouseKey() {
  return clickKeys[getEnv()] || clickKeys.qa;
};
/* 微信jssdk地址 */

var WEIXIN_JSSDK_URL = 'https://res.wx.qq.com/open/js/jweixin-1.6.2.js';
/* finclip jssdk地址 */

var FINCLIP_JSSDK_URL = 'https://public-1251849568.cos.ap-guangzhou.myqcloud.com/jssdk/finclip-jssdk-1.4.20.js';
/** 
 * 获取路由配置
 * 如果失败重发三次
 */

var routerConfig = function () {
  var result = null;
  return function () {
    if (result) return result;
    return fetch(getRouterConfigUrl(), {
      method: 'GET'
    }).then(function (response) {
      return response.json().then(function (data) {
        if (response.ok) {
          result = Promise.resolve(data);
          return result;
        } else {
          return Promise.reject('can not get router config');
        }
      });
    });
  };
}();

var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var base64 = {
  decode: function decode(string) {
    var result = '';
    var i = 0;

    do {
      var b1 = characters.indexOf(string.charAt(i++));
      var b2 = characters.indexOf(string.charAt(i++));
      var b3 = characters.indexOf(string.charAt(i++));
      var b4 = characters.indexOf(string.charAt(i++));
      var a = (b1 & 0x3F) << 2 | b2 >> 4 & 0x3;
      var b = (b2 & 0xF) << 4 | b3 >> 2 & 0xF;
      var c = (b3 & 0x3) << 6 | b4 & 0x3F;
      result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : '') + (c ? String.fromCharCode(c) : '');
    } while (i < string.length);

    return result;
  },
  encode: function encode(string) {
    var result = '';
    var i = 0;

    do {
      var a = string.charCodeAt(i++);
      var b = string.charCodeAt(i++);
      var c = string.charCodeAt(i++);
      a = a ? a : 0;
      b = b ? b : 0;
      c = c ? c : 0;
      var b1 = a >> 2 & 0x3F;
      var b2 = (a & 0x3) << 4 | b >> 4 & 0xF;
      var b3 = (b & 0xF) << 2 | c >> 6 & 0x3;
      var b4 = c & 0x3F;

      if (!b) {
        b3 = b4 = 64;
      } else if (!c) {
        b4 = 64;
      }

      result += characters.charAt(b1) + characters.charAt(b2) + characters.charAt(b3) + characters.charAt(b4);
    } while (i < string.length);

    return result;
  }
};

var platforms = ['PcWeb', 'MobileWeb', 'iOS', 'ANDROID', 'WechatMiniprogram', 'StoreCompanion', 'Harmony', 'unknown'];
var platformConfig = {
  unknown: {
    routerConfig: {
      name: 'web'
    },
    handler: 'web'
  },
  PcWeb: {
    routerConfig: {
      name: 'web'
    },
    handler: 'web'
  },
  MobileWeb: {
    routerConfig: {
      name: 'web'
    },
    handler: 'web'
  },
  iOS: {
    routerConfig: {
      name: 'app'
    },
    handler: 'app'
  },
  ANDROID: {
    routerConfig: {
      name: 'app'
    },
    handler: 'app'
  },
  WechatMiniprogram: {
    routerConfig: {
      name: 'smp'
    },
    handler: 'smp'
  },
  StoreCompanion: {
    routerConfig: {
      name: 'sc',
      fallback: 'smp'
    },
    handler: 'smp'
  },
  Harmony: {
    routerConfig: {
      name: 'harmony',
      fallback: 'smp'
    },
    handler: 'harmony',
    handlerFallback: 'smp'
  }
};

/* 统一的prefix入口 */

var prefix = function prefix(name) {
  return 'sdk_' + name;
};
/**
 * 获取webview平台信息
 * @returns { wechat_miniprogram | wechat_mobile | wechat_pc | app | web } webview平台信息
 * wechat_miniprogram: 微信小程序webview
 * wechat_mobile: 微信手机端webview
 * wechat_pc: 微信PC端webview
 * app: APP webview
 * harmony: 鸿蒙webview
 * web: 普通浏览器
 */


var getWebviewAgent = function getWebviewAgent() {
  var userAgent = navigator.userAgent || navigator.vendor || fakeWindow.opera;
  var platform = getPlatform();
  /* 鸿蒙使用platform判断更准确些，毕竟是finclip第三方 */

  if (platform === 'Harmony') {
    /* 鸿蒙webview */
    return 'harmony';
  }

  if (/MicroMessenger/i.test(userAgent)) {
    /* 微信小程序webview */
    if (/miniProgram/i.test(userAgent)) {
      return 'wechat_miniprogram';
    }

    if (/Android|iPhone|iPad|iPod|iOS/i.test(userAgent)) {
      /* 微信手机端webview */
      return 'wechat_mobile';
    }
    /* 微信PC端webview */


    return 'wechat_pc';
  }

  if (/ikea/i.test(userAgent)) {
    /* APP webview */
    return 'app';
  }

  return 'web';
};
/* 解析url地址 */

var parseURL = function parseURL(url) {
  var wholePath = url.split('//')[1] ? url.split('//')[1].split('?')[0] : '';
  var host = wholePath.split('/')[0];
  var path = wholePath.replace(host, '');
  var query = url.split('?')[1] ? url.split('?')[1] : '';
  return {
    source: url,
    protocol: url.split(':')[0],
    host: host,
    query: query,
    params: function () {
      var params = {},
          seg = query.split('&'),
          len = seg.length,
          p;

      for (var i = 0; i < len; i++) {
        if (seg[i]) {
          p = seg[i].split('=');
          params[p[0]] = p[1];
        }
      }

      return params;
    }(),
    path: path
  };
};
/** 
 * 只有sdk初始化时候的href会被记录
 * 防止页面跳转导致信息的丢失
 * 解析当前URI
 */

var href = location.href;
var getCurrentUri = function getCurrentUri() {
  return parseURL(href);
};
/* 获取cookie */

var getCookie = function getCookie(name) {
  var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)", 'i');
  if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
};
/* 判断是否登录 */

var isLogin$1 = function isLogin() {
  return !!getToken$1();
};
/**
 * 获取token
 * token失效的时候不返回token
 */

var getToken$1 = function getToken() {
  var platform = getPlatformConfig().handler;
  var token = '';
  /**
   * 小程序或者app的情况下为token
   * 此处需要加一个agent来判断是不是app，是因为在app中会有存在读不到platform的情况
   */

  if (platform === 'app' || platform === 'smp' || platform === 'harmony') {
    var _fakeWindow$sessionSt;

    token = ((_fakeWindow$sessionSt = fakeWindow.sessionStorage) === null || _fakeWindow$sessionSt === void 0 ? void 0 : _fakeWindow$sessionSt.getItem('token')) || getParam('token');
  } else {
    token = getParam('accessToken');
  }

  token = token.replace(/^Bearer/g, '').trim(); // 解析token获取exp

  var exp = tokenParse(token).exp;
  var now = Math.floor(Date.now() / 1000); // 判断token是否过期

  if (exp && exp < now) {
    token = '';
  }

  return token;
};
/** 
 * 所有的参数需获取
 */

var getParam = function getParam(name) {
  var platform = getPlatformConfig().handler;
  var value = '';

  if (platform === 'smp' || platform === 'harmony') {
    /* smp和harmony走url */
    value = getCurrentUri().params[name] || '';
  } else {
    /* 其他走cooikes */
    value = getCookie(name) || '';
  }
  /* 如果无法取值，输出错误 */


  if (!value) {
    console.warn("Unable to get param ".concat(name));
  }

  return value;
};
/* 获取clientVersion */

var getClientVersion = function getClientVersion() {
  var version = getParam('app_version') || '1.0.0';
  return version;
};
/* 获取platform */

var getPlatform = function getPlatform() {
  var platform = getCurrentUri().params.platform || getCookie('platform') || 'unknown';
  var index = platforms.findIndex(function (item) {
    return item.toLowerCase() === platform.toLowerCase();
  });
  platform = index > -1 ? platforms[index] : 'unknown';
  /* 在APP中可能存在读不到platform的情况，需要做兼容 */

  var userAgent = navigator.userAgent || navigator.vendor || fakeWindow.opera;

  if (/ikea/i.test(userAgent) && platform === 'unknown') {
    return /iPhone|iPad|iPod|iOS/i.test(userAgent) ? 'iOS' : 'ANDROID';
  }

  return platform;
};
/* 获取platform */

var getSessionId$1 = function getSessionId() {
  return getCookie('X-Client-SessionId') || getCookie("".concat(gioConfig.web.projectId, "_gr_session_id")) || getParam('gios') || undefined;
};
/* 获取deviceId */

var getDeviceId$1 = function getDeviceId() {
  var _fakeWindow$localStor;

  var deviceId = getParam('deviceId') || getCookie('gr_user_id') || ((_fakeWindow$localStor = fakeWindow.localStorage) === null || _fakeWindow$localStor === void 0 ? void 0 : _fakeWindow$localStor.getItem('deviceId')) || 'unknown';
  return deviceId;
};
/* 获取deviceId */

var getOsVersion$1 = function getOsVersion() {
  var osVersion = getParam('osVersion') || 'unknown';
  return osVersion;
};
/* 获取personalized */

var getPersonalized = function getPersonalized() {
  var personalized = getParam('personalized') || 'true';
  return personalized;
};
/* 获取deviceId */

var getDeviceModel$1 = function getDeviceModel() {
  var deviceModel = getParam('deviceModel') || 'unknown';
  return deviceModel;
};
/* 获取地理位置 */

var getAddressInfo$1 = function getAddressInfo() {
  var addressInfo = getParam('addressInfo') || 'null';
  return addressInfo;
};
/* 获取zipcode */

var getZipcode$1 = function getZipcode() {
  var zipcode = getParam('X-Client-Zipcode') || getParam('zipcode') || undefined;
  return zipcode;
};
/* 获取city */

var getCity = function getCity() {
  var city = getParam('X-Client-City') || undefined;
  return city;
};
/* 获取当前语言 */

var currentLanguage$1 = function currentLanguage() {
  var lang = getCookie('ikeacn_lang') || 'zh';
  return lang.toLowerCase();
};
/* 获取platform相关配置 */

var getPlatformConfig = function getPlatformConfig() {
  var platform = getPlatform();
  return platformConfig[platform];
};
/* 判断是否是对象 */

var isObject = function isObject(target) {
  return Object.prototype.toString.call(target) === '[object Object]';
};
/* 判断是否是字符串 */

var isString = function isString(target) {
  return Object.prototype.toString.call(target) === '[object String]';
};
var isArray = function isArray(target) {
  return Array.isArray(target);
};
var merge = function merge(target) {
  for (var _len = arguments.length, arg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arg[_key - 1] = arguments[_key];
  }

  return arg.reduce(function (acc, cur) {
    return Object.keys(cur).reduce(function (subAcc, key) {
      var srcVal = cur[key];

      if (isObject(srcVal)) {
        subAcc[key] = merge(subAcc[key] ? subAcc[key] : {}, srcVal);
      } else if (isArray(srcVal)) {
        // series: []，下层数组直接赋值
        subAcc[key] = srcVal.map(function (item, idx) {
          if (isObject(item)) {
            var curAccVal = subAcc[key] ? subAcc[key] : [];
            return merge(curAccVal[idx] ? curAccVal[idx] : {}, item);
          } else {
            return item;
          }
        });
      } else {
        subAcc[key] = srcVal;
      }

      return subAcc;
    }, acc);
  }, target);
};
/* url拼接参数 */

var appendParams = function appendParams(url, params) {
  if (params) {
    var hasParamsInPath = url.indexOf('?') >= 0;
    Object.keys(params).forEach(function (key, index) {
      if (index === 0 && !hasParamsInPath) {
        url += "?".concat(key, "=").concat(params[key]);
      } else {
        url += "&".concat(key, "=").concat(params[key]);
      }
    });
  }

  return url;
};
/* 获取一个包含promise本体，res，rej的对象 */

var getPromise = function getPromise() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  return {
    promise: promise,
    res: res,
    rej: rej
  };
};
/* 加载js文件 */

var loadJS = function loadJS(filePath) {
  var _getPromise = getPromise(),
      promise = _getPromise.promise,
      res = _getPromise.res,
      rej = _getPromise.rej;
  /* 预渲染模式下不加载链接 */


  if (getPrerender()) {
    res();
  } else {
    var script = document.createElement("script");
    script.type = "text/javascript";

    script.onload = function () {
      res();
    };
    /* 需要增加错误处理 */


    script.onerror = function () {
      rej();
    };

    script.src = filePath;
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  return promise;
};
/**
 * @description 版本检测 
 */

var checkVersion = function checkVersion(targetVersion, comparedVersion) {
  try {
    return satisfies(targetVersion, comparedVersion);
  } catch (_unused) {
    return false;
  }
};
/**
 * @description 与当前版本比较
 */

var compareVersion = function compareVersion(version) {
  return checkVersion(getClientVersion(), version);
};
/**
 * @description 根据当前channel，返回相应模块
 */

var channelFilter = function channelFilter(apiName, modules) {
  var calls = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var platformConfig = getPlatformConfig();
  var handler = platformConfig.handler;
  var fallbackHandler = platformConfig.handlerFallback;
  var module = modules[handler] || modules[fallbackHandler];
  var call = calls[handler] || calls[fallbackHandler];
  /* 没有定义该方法 */

  if (!module) {
    return function () {
      return fail(apiName, "not supported in ".concat(handler));
    };
  }

  call && call();
  return module;
};
/**
 * @description 解析token
 */

var tokenParse = function tokenParse(token) {
  if (!token) return {};
  var arr = token.split('.');
  if (arr.length <= 1) return {};
  var t = base64.decode(arr[1]);
  return JSON.parse(t);
};
/**
 * @description 获取用户partyUid
 */

var getPartyUid = function getPartyUid() {
  var partyUId = '';

  if (getToken$1()) {
    var t = tokenParse(getToken$1());
    partyUId = t.partyUId;
  }

  return partyUId;
};
/**
 * @description 获取渠道
 */

var getChannel = function getChannel() {
  var name = prefix('channel');
  var channel = getParam(name) || 'unknown';
  return channel;
};
/**
 * @description 随机字符串 
 */

var randomString = function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = $chars.length;
  var pwd = '';

  for (var i = 0; i < length; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
};
var trans2Object = function trans2Object(options) {
  var opt;

  if (isObject(options)) {
    opt = options;
  } else if (isString(options)) {
    opt = JSON.parse(options);
  }

  return opt;
};
/**
 * @description 方法之运行一次
 */

var runOnce = function runOnce(fn) {
  var hasRun = false;
  return function () {
    if (hasRun) return;
    hasRun = true;
    fn.apply(void 0, arguments);
  };
};
/**
 * @description 防抖
 */

var debounce = function debounce(func, delay) {
  var timerId;

  var debounced = function debounced() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    clearTimeout(timerId);
    timerId = setTimeout(function () {
      func.apply(void 0, args);
    }, delay);
  };

  debounced.cancel = function () {
    clearTimeout(timerId);
  };

  return debounced;
};
/* format date */

var formatNumber = function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : '0' + n;
};

var formatTime = function formatTime(timestamp, format) {
  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
  var returnArr = [];
  var date = new Date(timestamp);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  returnArr.push(year, month, day, hour, minute, second);
  returnArr = returnArr.map(formatNumber);

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }

  return format;
};

var match$1 = function match(input, originInput, ruleList) {
  var _iterator = _createForOfIteratorHelper(ruleList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rule = _step.value;
      var _match = null;

      if (rule.match instanceof RegExp) {
        _match = input.match(rule.match);
        _match = _match && _match[0];
      }

      if (rule.match instanceof Function) {
        _match = rule.match(input, originInput);
      }

      if (_match) {
        return {
          match: _match,
          type: rule.type,
          skip: rule.skip
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
};
/**
 * 分词器
 * 根据正则和方法返回token
 * 转义符号 \
 */


var tokenize = function tokenize(input, ruleList) {
  var offset = 0;
  var matchToken = match$1(input.slice(offset), input, ruleList);
  var tokens = []; // 初始token

  tokens.push({
    type: '^',
    match: '^',
    start: 0,
    end: 0
  });

  while (matchToken && offset < input.length) {
    if (!matchToken.skip) {
      tokens.push({
        type: matchToken.type,
        match: matchToken.match,
        start: offset,
        end: offset + matchToken.match.length
      });
    }
    /* 转义处理 */


    if (matchToken.type === 'escape') {
      /* 转义字符放在最后一位需要报错 */
      if (offset + 1 >= input.length) {
        throw new Error("Tokenize error: position ".concat(offset, ", invalid escape token"));
      }
      /* 将下一个字符视为char类型token */


      tokens.push({
        type: 'char',
        match: input[offset + 1],
        start: offset,
        end: offset += 2
      });
    } else {
      offset += matchToken.match.length;
    }

    matchToken = match$1(input.slice(offset), input, ruleList);
  }

  if (offset < input.length) {
    throw new Error("Tokenize error: position ".concat(offset));
  } // 结尾token


  tokens.push({
    type: '$',
    match: '$',
    start: input.length,
    end: input.length
  });
  return tokens;
};

/**
 * @description command解析工具
 * @command_a(abc@command_b(abc))
 * =>
 * 
 * [{
 *   command: 'a',
 *   value: [
 *    'abc'
 *    , {
 *     command: 'b',
 *     value: ['abc']
 *   }]
 * }]
 */
/**
 * 词法规则定义
 */

var tokenRuleList = [{
  type: 'escape',
  match: /^\\/,
  skip: true
}, {
  type: 'command',
  match: /^@command_[a-zA-Z0-9]+/
}, {
  type: 'big-brace',
  match: /^(\{\{|\}\})/
}, {
  type: 'bracket',
  match: /^(\(|\))/
}, {
  type: 'char',
  match: function match(input) {
    return input[0];
  }
}];
/**
 * @description 文法
 * Grammar = 'token-^', statements, 'token-$'
 * statements = {[statement]}
 * statement = command | literal
 * literal = {char}
 * commandExpr = 'token-command', '(', statements, ')'
 */

var parse = (function (input) {
  var tokens = tokenize(input, tokenRuleList);
  var tokensLength = tokens.length;
  var index = 0;
  var longestIndex = 0;

  var castError = function castError() {
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var newMsg = msg !== '' ? "parsing error in ".concat(tokens[index].end, ": ").concat(msg) : "parsing error: position ".concat(tokens[longestIndex].start);
    var error = new Error(newMsg);

    if (msg) {
      error.name = 'dead';
    }

    throw error;
  }; // 消费下一个token


  var read = function read() {
    if (index >= tokensLength) {
      return null;
    }

    var readToken = tokens[index];

    if (index > longestIndex) {
      longestIndex = index;
    }

    index++;
    return readToken;
  }; // 表达式式的token读取统一的收拢入口


  var readToken = function readToken(type, match) {
    var token = read();

    if (token === null || token.type !== type || match && token.match !== match) {
      // token读取错误需要将未知回退
      if (token !== null) {
        index--;
      }

      castError();
    }

    return token === null || token === void 0 ? void 0 : token.match;
  };
  /**
   * 当存在Expr = Expr1 | Expr2 ｜ Expr3时，必须对Expr1出错时做一下处理
   * 1. 回溯到Expr2
   * 2. 重置index位置
   * 全部出错则表示Expr出错
   */


  var orRead = function orRead() {
    var node = null;
    var currentIndex = index;

    for (var _len = arguments.length, readings = new Array(_len), _key = 0; _key < _len; _key++) {
      readings[_key] = arguments[_key];
    }

    for (var _i = 0, _readings = readings; _i < _readings.length; _i++) {
      var reading = _readings[_i];

      try {
        node = reading();
        break;
      } catch (e) {
        // 监测到打断回溯的错误，直接抛错
        if (e.name === 'dead') {
          throw e;
        }

        index = currentIndex;
      }
    }

    if (node === null) {
      castError();
    }

    return node;
  };
  /**
   * allowEmpty = true, {[Expr]}, 表示Expr出现0次或多次
   * allowEmpty = false, {Expr}, 表示Expr出现多次
   */


  var multiRead = function multiRead(reading) {
    var allowEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var nodes = [];
    var currentIndex = index;

    try {
      while (index < tokensLength) {
        var node = reading();
        nodes.push(node);
        currentIndex = index;
      }
    } catch (e) {
      index = currentIndex;

      if (e.name === 'dead') {
        throw e;
      }

      if (!allowEmpty && nodes.length === 0) {
        castError();
      }
    }

    return nodes;
  };

  var readGrammar = function readGrammar() {
    readToken('^');
    var node = readStatements();
    readToken('$');
    return node;
  };

  var readStatements = function readStatements() {
    return multiRead(readStatement);
  };

  var readStatement = function readStatement() {
    return orRead(readCommand, readInterpolation, readLiteral);
  };

  var readCommand = function readCommand() {
    var node = {
      type: 'command',
      command: '',
      value: ''
    };
    var commandToken = readToken('command');
    node.command = commandToken === null || commandToken === void 0 ? void 0 : commandToken.split('@command_')[1];

    try {
      readToken('bracket', '(');
      node.value = readStatements();
      readToken('bracket', ')');
    } catch (_unused) {
      castError('invalid command');
    }

    return node;
  };
  /**
   * 插值表达式
   * {{xxx}}
   */


  var readInterpolation = function readInterpolation() {
    var node = {
      type: 'interpolation',
      value: ''
    };
    readToken('big-brace', '{{');

    try {
      node.value = readLiteral().value;
      readToken('big-brace', '}}');
    } catch (_unused2) {
      castError('invalid interpolation');
    }

    return node;
  };

  var readLiteral = function readLiteral() {
    var nodes = multiRead(function () {
      return readToken('char');
    }, false);
    return {
      type: 'literal',
      value: nodes.join('')
    };
  };

  return readGrammar();
});

/**
 * @description 路由path支持命令符
 */

var commands = {
  /**
   * @description url-encode
   * @command_encode()
   */
  encode: function encode(str) {
    return encodeURIComponent(formatParams(str));
  },

  /**
   * @description app/smp h5页面前缀
   * @command_h5path()
   */
  h5path: function h5path(str) {
    var _isHttp = isHttp(str);

    var platform = getPlatform();

    if (platform === 'WechatMiniprogram' || platform === 'StoreCompanion' || platform === 'Harmony') {
      if (_isHttp) return "/pages/h5page/h5page?h5link=".concat(encodeURIComponent(formatParams(str)));
      return "/pages/h5page/h5page?h5path=".concat(encodeURIComponent(formatParams(str)));
    } else if (platform === 'iOS' || platform === 'ANDROID') {
      if (_isHttp) return "/web?url=".concat(encodeURIComponent(formatParams(str)));
      return "/web?path=".concat(encodeURIComponent(formatParams(str)));
    } else {
      return str;
    }
  },

  /**
   * @description 处理share链接
   * @command_shareLink()
   * @param str {"isH5Card":"{{isH5Card}}","link":"{{link}}","originImageUrl":"{{originImageUrl}}","path":"{{path}}","poster":"{{poster}}","imageUrl":"{{imageUrl}}","title":"{{title}}","trackSource":"{{trackSource}}"}
   */
  shareLink: function shareLink(str) {
    var constReg = /\{\{([^\{\}]+)\}\}/;
    var params = JSON.parse(str);
    Object.keys(params).forEach(function (key) {
      if (constReg.test(params[key])) delete params[key];
    });
    var platform = getPlatform();
    var link = '';
    var poster = params.poster;
    var title = params.title;
    var imageUrl = params.imageUrl;
    var originImageUrl = params.originImageUrl;
    var posterRatio = params.posterRatio;
    var isH5Card = params.isH5Card;

    if (platform === 'WechatMiniprogram' || platform === 'StoreCompanion' || platform === 'Harmony') {
      if (params.link) link = "/pages/h5page/h5page?h5link=".concat(encodeURIComponent(params.link));
      if (params.path) link = params.path;
      return "/pages/share/share?sharePath=".concat(encodeURIComponent(link)).concat(imageUrl ? '&shareThumbnail=' + encodeURIComponent(imageUrl) : '').concat(poster ? '&shareImageUrl=' + encodeURIComponent(poster) : '').concat(title ? '&shareTitle=' + title : '').concat(originImageUrl ? '&originImageUrl=' + encodeURIComponent(originImageUrl) : '').concat(posterRatio ? '&posterRatio=' + posterRatio : '', "&shareImageUrlType=image");
    } else if (platform === 'iOS' || platform === 'ANDROID') {
      var data = {
        mpAppUserName: 'gh_f8c80781c128',
        trackSource: params.trackSource || 'web'
      };
      /* H5卡片形式 */

      if (params.link && isH5Card) data.link = encodeURIComponent(params.link);
      /* 小程序H5卡片形式 */

      if (params.link && !isH5Card) data.path = encodeURIComponent("/pages/h5page/h5page?h5link=".concat(encodeURIComponent(params.link)));
      /* 小程序原生路径形式 */

      if (params.path) data.path = encodeURIComponent(params.path);
      if (poster) data.poster = poster;
      if (title) data.title = title;
      if (imageUrl) data.imageUrl = imageUrl;
      if (originImageUrl) data.originImageUrl = originImageUrl;
      if (posterRatio) data.originImageUrl = posterRatio;
      return "/shareInfo?data=".concat(encodeURIComponent(JSON.stringify(data)));
    } else {
      return str;
    }
  }
};
var translate = (function (path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var commandNodes = parse(path);

  var traverseNode = function traverseNode(node) {
    if (node.type === 'literal') return node.value;
    if (node.type === 'command') return commands[node.command](node.value.map(function (n) {
      return traverseNode(n);
    }).join(''));
    if (node.type === 'interpolation') return params[node.value] || '';
    /* 兜底，不会走到这一步 */

    return '';
  };

  return commandNodes.map(function (node) {
    return traverseNode(node);
  }).join('');
});

/**
 * @description 路由的参数检测
 */

var checkParams = function checkParams(paramsConfig, params) {
  /* 判断必须存在参数是否存在 */
  var isAllParamsIncluded = Object.keys(paramsConfig).every(function (key) {
    if (paramsConfig[key].type === 'required') {
      return params[key] !== undefined;
    }

    return true;
  });
  return isAllParamsIncluded;
};
/**
 * @description 路径的通配替换
 * @param path 路径
 * @param pathObject 路径对象
 * @caution 路径匹配格式为{{}}
 */

var pathReplace = function pathReplace(path, pathObject) {
  /* command执行 */
  var replacedPath = translate(path, pathObject.receivedParams);
  return formatParams(replacedPath);
};

var splitUrl = function splitUrl(str) {
  var match = str.match(/^(.*?)\?(.*)$/); // 如果匹配成功，返回问号前后两部分

  if (match) {
    return [match[1], match[2]];
  } else {
    return [str, ''];
  }
};
/** 
 * 规范参数
 * 1. 去除param=格式的字符串
 * 2. 将多余的?替换为&
 */


var formatParams = function formatParams(path) {
  var _splitUrl = splitUrl(path),
      _splitUrl2 = _slicedToArray$1(_splitUrl, 2),
      _path = _splitUrl2[0],
      query = _splitUrl2[1];

  var params = {};

  if (query) {
    query.split(/\?|&/).forEach(function (param) {
      var _param$split = param.split('='),
          _param$split2 = _slicedToArray$1(_param$split, 2),
          key = _param$split2[0],
          value = _param$split2[1];

      if (!value) {
        return;
      }

      params[key] = value || '';
    });
  }

  var nextQuery = Object.keys(params).map(function (key) {
    return "".concat(key, "=").concat(params[key]);
  }).join('&');
  return nextQuery ? _path + '?' + nextQuery : _path;
};
/**
 * sdk每次跳转都会触发跳转监听
 */

var onNavigateTo = function onNavigateTo() {
  fakeWindow.jsBridge.onNavigateTo && fakeWindow.jsBridge.onNavigateTo();
};
/**
 * 判断是否是http链接
 */

var isHttp = function isHttp(link) {
  var httpReg = /^(http|https|ftp)\:\/\//i;
  return httpReg.test(link);
};

/* hex output format. 0 - lowercase; 1 - uppercase        */

var chrsz = 8;
/* bits per input character. 8 - ASCII; 16 - Unicode      */

function hex_md5(s) {
  return binl2hex(core_md5(str2binl(s), s.length * chrsz));
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */


function core_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}

function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bit_rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * Convert a string to an array of little-endian words
 * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
 */


function str2binl(str) {
  var bin = [];
  var mask = (1 << chrsz) - 1;

  for (var i = 0; i < str.length * chrsz; i += chrsz) {
    bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << i % 32;
  }

  return bin;
}
/*
 * Convert an array of little-endian words to a hex string.
 */


function binl2hex(binarray) {
  var hex_tab = '0123456789abcdef';
  var str = '';

  for (var i = 0; i < binarray.length * 4; i++) {
    str += hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 & 0xF);
  }

  return str;
}

/* 当url schema形式的路由检测到该prefix参数的时候，会寻求业务方进行业务托管 */
var ROUTER_DELEGATE_PREFIX = 'sdk-router-delegate__';
/**
 * @description 路由基类
 * @function navigateTo 跳转方法
 * @function canNavigateTo 判断是否能导航至该路径
 */

var BaseRouter = /*#__PURE__*/function () {
  function BaseRouter() {
    _classCallCheck$1(this, BaseRouter);

    _defineProperty(this, "routerPlatform", getPlatformConfig().routerConfig.name);

    _defineProperty(this, "routerPlatformFallback", getPlatformConfig().routerConfig.fallback);

    _defineProperty(this, "delegateHander", null);
  }

  _createClass$1(BaseRouter, [{
    key: "delegate",
    value: function delegate(delegateHander) {
      this.delegateHander = delegateHander;
    }
    /**
     * @description 获取相应的routerObject
     */

  }, {
    key: "getRouterObject",
    value: function getRouterObject(pathObject) {
      return pathObject[this.routerPlatform] || this.routerPlatformFallback && pathObject[this.routerPlatformFallback];
    }
    /**
     * @description 路由对象判断，防止用户传入错误类型
     */

  }, {
    key: "checkPathObject",
    value: function checkPathObject(pathObject) {
      /* 至少是个对象 */
      if (!isObject(pathObject)) return false;
      /* 至少有对应的路由存在 */

      if (!this.getRouterObject(pathObject)) return false;
      return true;
    }
    /**
     * @description 路由版本判断
     */

  }, {
    key: "checkVersion",
    value: function checkVersion(pathObject) {
      var routerObject = this.getRouterObject(pathObject);
      if (routerObject.version) return compareVersion(routerObject.version);
      return true;
    }
    /**
     * @description 路由参数判断
     */

  }, {
    key: "checkParams",
    value: function checkParams$1(pathObject) {
      return checkParams(pathObject.params || {}, pathObject.receivedParams || {});
    }
    /**
     * @description 增加参数
     */

  }, {
    key: "appendParams",
    value: function appendParams$1(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return appendParams(url, params);
    }
    /**
     * @description 为地址添加refer参数
     */

  }, {
    key: "appendRefer",
    value: function appendRefer(url) {
      var refer = getRefer();

      if (refer) {
        return appendParams(url, refer);
      }

      return url;
    }
    /**
     * 根据url进行跳转
     */

  }, {
    key: "linkTo",
    value: function linkTo(url, options) {
      var _this = this;

      return BaseRouter.convertUrl2PathObject(url).then(function (result) {
        var apiName = options && options.apiName || 'navigateTo';

        if (result) {
          /* 需要业务方进行委托 */
          if (_this.delegateHander) {
            /* 收集delegate参数 */
            var delegateActions = [];
            Object.keys(result.receivedParams || {}).forEach(function (key) {
              if (key.startsWith(ROUTER_DELEGATE_PREFIX)) {
                delegateActions.push(key.replace(ROUTER_DELEGATE_PREFIX, ''));
                /* 删除委托参数 */

                delete result.receivedParams[key];
              }
            });
            var parsedUrlSchema = BaseRouter.parseUrlSchema(url);

            if (parsedUrlSchema) {
              var module = parsedUrlSchema.module,
                  name = parsedUrlSchema.name;
              url = appendParams("ikea://".concat(module, "/").concat(name), result.receivedParams);
            }

            var useNext = false;

            _this.delegateHander(url, delegateActions, {
              convertUrlSchemaToLink: BaseRouter.convertUrlSchemaToLink,
              next: function next() {
                useNext = true;
              }
            });
            /* 在返回值不为null的情况下，跳过默认行为，直接返回 */


            if (!useNext) {
              return apiInvokeSuccess(apiName);
            }
          }

          return _this.navigateTo(result, options);
        }

        return fail(apiName, "router (".concat(url, ") not found"));
      });
    }
    /**
     * 判断url是否能跳转
     */

  }, {
    key: "canLinkTo",
    value: function canLinkTo(url) {
      var _this2 = this;

      return BaseRouter.convertUrl2PathObject(url).then(function (result) {
        if (result) {
          return _this2.canNavigateTo(result);
        }

        return apiInvokeSuccess('canNavigateTo', false);
      });
    }
    /**
     * @description 路由跳转方法
     * @param pathObject 跳转对象
     * @param options.redirect 是否重定向
     * @param options.newTab 是否新打开一个窗口, 仅web生效
     * @param options.escapeParams 需要携带的外部参数
     * @param options.custOptions 额外的参数扩展
     * @param options.apiName 用于log，不对业务开放式
     */

  }, {
    key: "redirectTo",
    value:
    /**
     * @description 路由重定向方法
     * @param pathObject 跳转对象
     * @param options.escapeParams 需要携带的外部参数
     * @param options.custOptions 额外的参数扩展
     */
    function redirectTo(pathObject, options) {
      return this.navigateTo(pathObject, _objectSpread2(_objectSpread2({}, options), {}, {
        redirect: true,
        apiName: 'redirectTo'
      }));
    }
    /**
     * @description 打开新窗口方法
     * @param pathObject 跳转对象
     * @param options.escapeParams 需要携带的外部参数
     * @param options.custOptions 额外的参数扩展
     */

  }, {
    key: "newTabTo",
    value: function newTabTo(pathObject, options) {
      return this.navigateTo(pathObject, _objectSpread2(_objectSpread2({}, options), {}, {
        newTab: true,
        apiName: 'redirectTo'
      }));
    }
    /**
     * @description 是否可以跳转判断
     * @param pathObject 跳转对象
     */

  }, {
    key: "openH5",
    value:
    /**
     * @description 打开h5页面
     * @param h5Link h5地址
     * @param needNavigation 是否需要关闭webview导航栏(仅app有效) 默认为true
     * @param physicalBack 是否需要webview手势返回(仅app有效) 默认为true
     */
    function openH5(h5Link, params) {
      return this.navigateTo("ikea://default-module/H5?url=".concat(encodeURIComponent(h5Link)), {
        apiName: 'openH5',
        escapeParams: params
      });
    }
    /**
     * @description 重定向h5页面
     * @param h5Link h5地址
     */

  }, {
    key: "redirectH5",
    value: function redirectH5(h5Link, params) {
      return this.navigateTo("ikea://default-module/H5?url=".concat(encodeURIComponent(h5Link)), {
        apiName: 'redirectH5',
        redirect: true,
        escapeParams: params
      });
    }
    /**
     * @description 打开新窗口h5页面
     * @param h5Link h5地址
     */

  }, {
    key: "newTabH5",
    value: function newTabH5(h5Link, params) {
      return this.navigateTo("ikea://default-module/H5?url=".concat(encodeURIComponent(h5Link)), {
        apiName: 'newTabH5',
        newTab: true,
        escapeParams: params
      });
    }
    /**
     * @description 跳转支付页面
     * @param options.checkoutId 订单checkout id
     * @param options.checkoutType checkout类型
     * @param options.redirectRoute 重定向页面，默认走原生
     * @param options.autoRedirect 是否自动跳转，默认为true
     * @param options.buttonName 按钮名称
     * @param options.storeId 门店id
     */

  }, {
    key: "goToPayment",
    value: function goToPayment(options) {
      var checkoutId = options.checkoutId,
          checkoutType = options.checkoutType,
          autoRedirect = options.autoRedirect,
          buttonName = options.buttonName,
          storeId = options.storeId;
      var redirectRoute = _typeof(options.redirectRoute) === 'object' ? encodeURIComponent(JSON.stringify(options.redirectRoute)) : typeof options.redirectRoute === 'string' ? encodeURIComponent(options.redirectRoute) : null;
      var params = "?checkoutId=".concat(checkoutId).concat(checkoutType ? "&checkoutType=".concat(checkoutType) : '').concat(redirectRoute ? "&redirectRoute=".concat(redirectRoute) : '').concat(autoRedirect ? "&autoRedirect=".concat(autoRedirect) : '').concat(buttonName ? "&buttonName=".concat(buttonName) : '').concat(storeId ? "&storeId=".concat(storeId) : '');
      return this.redirectTo("ikea://payment/payment".concat(params));
    }
    /**
     * @description 跳转分享页面
     * @param options.title 标题
     * @param options.poster 海报，如果没有的话会根据link自动生成，link和poster不能都不存在
     * @param options.path 原生路径
     * @param options.link H5地址，link和poster不能都不存在
     * @param options.wechatShareImage 微信分享的头图
     * @param options.trackSource App使用埋点数据
     * @param options.originImageUrl 原图，用于下载
     * @param options.posterRatio 海报图比例参数
     * @param options.isH5Card 是否以h5卡片分享
     */

  }, {
    key: "goToShare",
    value: function goToShare(options) {
      /* 鸿蒙暂时不支持 */
      var platform = getPlatform();
      if (platform === 'Harmony') return fail('goToShare', 'Harmony not supported');
      var title = options.title,
          path = options.path,
          link = options.link,
          wechatShareImage = options.wechatShareImage,
          trackSource = options.trackSource,
          poster = options.poster,
          originImageUrl = options.originImageUrl,
          posterRatio = options.posterRatio;
      var truePoster = poster || '';

      if (link && !poster) {
        var WEBSHOT_KEY = 'ikea';
        var timeStamp = new Date().getTime();
        var sign = hex_md5(timeStamp + WEBSHOT_KEY);
        truePoster = "https://webshot.app.ikea.cn/?&timestamp=".concat(timeStamp, "&sign=").concat(sign, "&url=").concat(encodeURIComponent(this.appendParams(link, {
          webshot: 'true'
        })), "&fullPage=false&width=375&height=677");
      }

      if (!poster && !link) return fail('goToShare', 'poster is required while link is undefined');
      /* TMD就是这么无语！ */

      if (['iOS', 'ANDROID'].includes(platform)) {
        truePoster = encodeURIComponent(truePoster);
      }

      return this.navigateTo('ikea://default-module/share' + "?poster=".concat(encodeURIComponent(truePoster)) + "&title=".concat(encodeURIComponent(title)) + "&isH5Card=".concat(options.isH5Card || '') + "&path=".concat(encodeURIComponent(path || '')) + "&link=".concat(encodeURIComponent(link || '')) + "&imageUrl=".concat(encodeURIComponent(wechatShareImage || '')) + "&originImageUrl=".concat(encodeURIComponent(originImageUrl || '')) + "&posterRatio=".concat(posterRatio) + "&trackSource=".concat(encodeURIComponent(trackSource || '')), {
        apiName: 'goToShare'
      });
    }
  }], [{
    key: "parseUrlSchema",
    value: function parseUrlSchema(url) {
      var reg = /^(https:\/\/ikeaapp\/|ikea:\/\/)([\w-]+)\/([\w-]+)/;
      var match = url.match(reg);

      if (!match) {
        return false;
      }

      var module = match[2];
      var name = match[3];
      var receivedParams = parseURL(url).params;
      return {
        module: module,
        name: name,
        receivedParams: receivedParams
      };
    }
    /**
     * @description 将url字符串转化为pathObject
     * 1. url格式为ikea://{{module}}/{{name}}?params或者ikea://{{module}}/{{name}}?params 形式
     * 2. pathObject会在routerConfig中寻找
     * 3. params需要统一的decode
     */

  }, {
    key: "convertUrl2PathObject",
    value: function convertUrl2PathObject(url) {
      return routerConfig().then(function (config) {
        var parsedUrlSchema = BaseRouter.parseUrlSchema(url);
        if (!parsedUrlSchema) return false;
        var module = parsedUrlSchema.module,
            name = parsedUrlSchema.name,
            receivedParams = parsedUrlSchema.receivedParams;
        Object.keys(receivedParams).forEach(function (key) {
          receivedParams[key] = decodeURIComponent(receivedParams[key]);
        });
        var router = config[module] && config[module].find(function (subModule) {
          return subModule.name === name;
        });

        if (router) {
          return _objectSpread2(_objectSpread2({}, router.channels), {}, {
            params: router.params,
            receivedParams: receivedParams
          });
        }

        return false;
      })["catch"](function () {
        return false;
      });
    }
  }, {
    key: "convertUrlSchemaToLink",
    value: function convertUrlSchemaToLink(schema) {
      var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getPlatformConfig().handler;
      var pathName = arguments.length > 2 ? arguments[2] : undefined;
      return BaseRouter.convertUrl2PathObject(schema).then(function (pathObject) {
        if (pathObject) {
          var routerObject = pathObject[platform];
          if (!routerConfig) return false;

          if (!pathName) {
            if (platform === 'web') {
              pathName = 'visitPath';
            } else {
              pathName = 'path';
            }
          }

          return pathReplace(routerObject[pathName] || '', pathObject);
        }

        return false;
      });
    }
    /** 
     * @description 在routerConfig中的路由平台
     */

  }]);

  return BaseRouter;
}();

var compare = function compare(api, minVersion, channel) {
  var currentVersion = getClientVersion();

  if (!checkVersion(currentVersion, minVersion)) {
    return fail(api, "not supported for the version ".concat(currentVersion, " in ").concat(channel));
  }
};
/**
 * @description 判断版本装饰器
 * @param minVersion 最低版本
 * @param channel 哪一个channel
 * @param apiName 限制的api名
 */


var version$1 = function version(minVersion, channel, apiName) {
  return function (_target, propertyName, descriptor) {
    var originalMethod = descriptor.value;

    descriptor.value = function () {
      var result = compare(apiName || propertyName, minVersion, channel);
      if (result !== undefined) return result;
      return originalMethod.apply(this, arguments);
    };
  };
};
/**
 * @description 判断版本方法
 * @param minVersion 最低版本
 * @param channel 哪一个channel
 * @param fn api方法
 * @param apiName 限制的api名
 */

var versionFn = function versionFn(minVersion, channel, fn, apiName) {
  return function () {
    var result = compare(apiName || fn.name, minVersion, channel);
    if (result !== undefined) return result;
    return fn.apply(null, arguments);
  };
};

/**
 * @description 与端通信的统一接口
 */

/** 
 * 存放需要端回调的方法
 * 增加globalThis是为了兼容node环境
 */

fakeWindow.jsBridge = {};
var callbackIndex = 0;

var Bridge = /*#__PURE__*/function () {
  function Bridge() {
    _classCallCheck$1(this, Bridge);

    _defineProperty(this, "poster", null);

    _defineProperty(this, "receiver", null);
  }

  _createClass$1(Bridge, [{
    key: "registerCallBacks",
    value:
    /* 注册callback，并在运行后自动注销 */
    function registerCallBacks() {
      for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
        callbacks[_key] = arguments[_key];
      }

      if (callbacks.length < 1) {
        throw new Error('registerCallBacks需要至少一个回调参数');
      }

      var callbackNames = callbacks.map(function () {
        return "web_cb".concat(callbackIndex++);
      });
      callbackNames.forEach(function (name, index) {
        fakeWindow.jsBridge[name] = function () {
          callbacks[index].apply(callbacks, arguments);
          callbackNames.forEach(function (callbackName) {
            delete fakeWindow.jsBridge[callbackName];
          });
        };
      });
      return callbackNames;
    }
    /* 调用native端api */

  }, {
    key: "call",
    value: function call(apiName, name) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _getPromise = getPromise(),
          promise = _getPromise.promise,
          res = _getPromise.res,
          rej = _getPromise.rej; // 将回调方法注册入回调队列


      var _this$registerCallBac = this.registerCallBacks(res, rej),
          _this$registerCallBac2 = _slicedToArray$1(_this$registerCallBac, 2),
          cb1 = _this$registerCallBac2[0],
          cb2 = _this$registerCallBac2[1];

      if (!this.poster) return Promise.reject('请注册poster');
      var msg = this.poster(name, params, cb1, cb2);

      if (msg) {
        return fail(apiName, msg);
      }

      return promise.then(function (data) {
        return apiInvokeSuccess(apiName, data);
      })["catch"](function (data) {
        return fail(apiName,
        /* 无论对象还是字符串，统一处理 */
        JSON.stringify(data));
      });
    }
    /* 注册方法提供native调用 */

  }, {
    key: "register",
    value: function register(name, fn) {
      fakeWindow.jsBridge[name] = fn;
    }
    /* 注册信息发布者 */

  }, {
    key: "registerPoster",
    value: function registerPoster(fn) {
      this.poster = fn;
    }
    /* 注册信息接收者 */

  }, {
    key: "registerReceiver",
    value: function registerReceiver(fn) {
      this.receiver = fn;
      this.receiver();
    }
    /**
     * native调用js端api
     * on的行为是覆盖式的，对同一个事件的监听会以最后一个事件为准
     */

  }, {
    key: "on",
    value: function on(name, fn) {
      this.register(name, fn);
    }
  }]);

  return Bridge;
}();

/**
 * @description appBridge的具体实现
 */

var setup = function setup() {
  var _fakeWindow, _fakeWindow$flutter_i;

  var _getPromise = getPromise(),
      promise = _getPromise.promise,
      res = _getPromise.res;

  var callHandler = (_fakeWindow = fakeWindow) === null || _fakeWindow === void 0 ? void 0 : (_fakeWindow$flutter_i = _fakeWindow.flutter_inappwebview) === null || _fakeWindow$flutter_i === void 0 ? void 0 : _fakeWindow$flutter_i.callHandler;

  if (callHandler) {
    res(fakeWindow.flutter_inappwebview);
  } else {
    fakeWindow.addEventListener('flutterInAppWebViewPlatformReady', function () {
      res(fakeWindow.flutter_inappwebview);
    }, false);
  }

  return promise;
};

var bridge$4 = new Bridge();
var isSetup = setup();
bridge$4.registerPoster(function (name, params, cb1, cb2) {
  isSetup.then(function () {
    var _fakeWindow2, _fakeWindow2$flutter_;

    var args = [name];
    if (params) args.push(params);
    var callHandler = (_fakeWindow2 = fakeWindow) === null || _fakeWindow2 === void 0 ? void 0 : (_fakeWindow2$flutter_ = _fakeWindow2.flutter_inappwebview) === null || _fakeWindow2$flutter_ === void 0 ? void 0 : _fakeWindow2$flutter_.callHandler;

    if (!callHandler) {
      console.error('no app bridge found');
      return;
    }

    try {
      callHandler.apply(void 0, args).then(function (result) {
        fakeWindow.jsBridge[cb1](result);
      })["catch"](function (error) {
        fakeWindow.jsBridge[cb2](error);
      });
    } catch (err) {
      /* 改处错误一般预示着bridge失效或其他错误 */
      fakeWindow.jsBridge[cb2]("app bridge error: ".concat(err.message));
      console.error('app bridge error: ', name, params, err);
    }
  });
});

var _dec$2, _dec2$1, _class$2;
var AppRouter = (_dec$2 = version$1('>=2.3.0', 'app'), _dec2$1 = version$1('>=2.0.0', 'app'), (_class$2 = /*#__PURE__*/function (_BaseRouter) {
  _inherits(AppRouter, _BaseRouter);

  var _super = _createSuper(AppRouter);

  function AppRouter() {
    _classCallCheck$1(this, AppRouter);

    return _super.apply(this, arguments);
  }

  _createClass$1(AppRouter, [{
    key: "navigateTo",
    value: function navigateTo(pathObject, options) {
      if (typeof pathObject === 'string') {
        return this.linkTo(pathObject, options);
      }

      if (!this.checkPathObject(pathObject)) {
        return fail('navigateTo', 'invalid args');
      }

      if (!this.checkVersion(pathObject)) {
        return fail('navigateTo', 'version are not compatible in app');
      }

      if (!this.checkParams(pathObject)) {
        return fail('navigateTo', 'params are not compatible');
      }

      var apiName = options && options.apiName || 'navigateTo';
      var routerObject = this.getRouterObject(pathObject);
      if (!routerObject.path) return fail(apiName, 'no path found');
      if (routerObject.path === 'unsupported') return fail(apiName, 'unsupported in app');
      var redirect = options && options.redirect || false;
      var escapeParams = options && options.escapeParams || {};
      return bridge$4.call(apiName, 'push', {
        path: 'https://ikeaapp' + this.appendRefer(this.appendParams(pathReplace(routerObject.path, pathObject), escapeParams)),
        popCurrent: redirect
      });
    }
  }, {
    key: "canNavigateTo",
    value: function canNavigateTo(pathObject) {
      if (typeof pathObject === 'string') {
        return this.canLinkTo(pathObject);
      }

      if (!this.checkPathObject(pathObject) || !this.checkVersion(pathObject)) {
        return apiInvokeSuccess('canNavigateTo', false);
      }

      return apiInvokeSuccess('canNavigateTo', true);
    }
  }, {
    key: "navigateBack",
    value: function navigateBack() {
      return bridge$4.call('navigateBack', 'popCurrent');
    }
  }]);

  return AppRouter;
}(BaseRouter), (_applyDecoratedDescriptor(_class$2.prototype, "navigateTo", [_dec$2], Object.getOwnPropertyDescriptor(_class$2.prototype, "navigateTo"), _class$2.prototype), _applyDecoratedDescriptor(_class$2.prototype, "navigateBack", [_dec2$1], Object.getOwnPropertyDescriptor(_class$2.prototype, "navigateBack"), _class$2.prototype)), _class$2));
var appRouter = new AppRouter();

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime_1 = createCommonjsModule(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var regenerator = runtime_1;

/* 单例相关方法 */
var singletonRecord = {};
/**
 * 获取一个单例
 * key：单例名
 * initializer：单例初始化
 * refreshTiming：刷新单例时机
 */

var singleton = function singleton(key, initializer, refreshTiming) {
  if (singletonRecord[key]) {
    return singletonRecord[key];
  }

  var obj = initializer();
  singletonRecord[key] = obj;

  if (refreshTiming) {
    var result = refreshTiming(singletonRecord[key]);

    if (result instanceof Promise) {
      /* 返回的是promise */
      result.then(function (judge) {
        judge && delete singletonRecord[key];
      });
    } else if (result === true) {
      /* 返回的是boolean */
      delete singletonRecord[key];
    }
  }

  return obj;
};

/* 防一手改动地址 */

var _fakeWindow$location = fakeWindow.location,
    origin = _fakeWindow$location.origin,
    pathname = _fakeWindow$location.pathname,
    search = _fakeWindow$location.search;
var wxAuthUrl = origin + pathname + search;
/* 加载wxsdk */

var loadWxJssdk = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
  var agent, platform;
  return regenerator.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          agent = getWebviewAgent();
          platform = getPlatform();
          /* 防止重复加载 */

          if (!(fakeWindow && fakeWindow.wx)) {
            _context.next = 4;
            break;
          }

          return _context.abrupt("return", Promise.resolve('wx-js-sdk loaded'));

        case 4:
          if (!(platform === 'Harmony')) {
            _context.next = 16;
            break;
          }

          _context.prev = 5;
          _context.next = 8;
          return loadJS(FINCLIP_JSSDK_URL);

        case 8:
          /* 将api统一挂载在wx上 */
          fakeWindow.wx = fakeWindow.ft;
          _context.next = 14;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](5);
          return _context.abrupt("return", Promise.reject('load wx-js-sdk ( finclip ) failed'));

        case 14:
          _context.next = 28;
          break;

        case 16:
          if (!(platform === 'WechatMiniprogram' || ['wechat_pc', 'wechat_mobile', 'wechat_miniprogram'].includes(agent))) {
            _context.next = 27;
            break;
          }

          _context.prev = 17;
          _context.next = 20;
          return loadJS(WEIXIN_JSSDK_URL);

        case 20:
          _context.next = 25;
          break;

        case 22:
          _context.prev = 22;
          _context.t1 = _context["catch"](17);
          return _context.abrupt("return", Promise.reject('load wx-js-sdk ( wechat ) failed'));

        case 25:
          _context.next = 28;
          break;

        case 27:
          return _context.abrupt("return", Promise.reject('can not load wx-js-sdk in this platform: ' + platform));

        case 28:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[5, 11], [17, 22]]);
}))();
/* 初始化微信sdk */

var initWxJssdk = function initWxJssdk() {
  return singleton('init-wx-jssdk', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var platform;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return loadWxJssdk;

          case 2:
            platform = getPlatform();
            /* 鸿蒙环境加载的是finclip，不需要sdk初始化 */

            if (!(platform === 'Harmony')) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", Promise.resolve('finclip sdk initialized'));

          case 5:
            return _context2.abrupt("return", fetch("".concat(getMBFFHost(), "/wechat/jssdk/sign"), {
              method: 'POST',
              headers: {
                'content-type': 'application/json'
              },
              body: JSON.stringify({
                url: wxAuthUrl,
                appId: ['wechat_pc', 'wechat_mobile'].includes(getWebviewAgent()) ? '7673c514bbc04fafaf0c3fcd7c562c8c' : undefined
              })
            }).then(function (response) {
              return response.json().then(function (data) {
                if (response.ok) {
                  var appId = data.appId,
                      timestamp = data.timestamp,
                      nonce = data.nonce,
                      signature = data.signature;

                  var _getPromise = getPromise(),
                      promise = _getPromise.promise,
                      res = _getPromise.res,
                      rej = _getPromise.rej;

                  fakeWindow.wx.config({
                    debug: false,
                    appId: appId,
                    timestamp: timestamp,
                    nonceStr: nonce,
                    signature: signature,
                    jsApiList: API_LIST,
                    openTagList: OPEN_TAG_LIST
                  });
                  fakeWindow.wx.ready(function () {
                    res();
                  });
                  fakeWindow.wx.error(function (e) {
                    rej('wx-js-sdk initialized failed: ' + JSON.stringify(e));
                  });
                  return promise;
                } else {
                  return Promise.reject('sign got failed');
                }
              });
            }));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
};

var SmpRouter = /*#__PURE__*/function (_BaseRouter) {
  _inherits(SmpRouter, _BaseRouter);

  var _super = _createSuper(SmpRouter);

  function SmpRouter() {
    _classCallCheck$1(this, SmpRouter);

    return _super.apply(this, arguments);
  }

  _createClass$1(SmpRouter, [{
    key: "navigateTo",
    value: function navigateTo(pathObject, options) {
      if (typeof pathObject === 'string') {
        return this.linkTo(pathObject, options);
      }

      if (!this.checkPathObject(pathObject)) {
        return fail('navigateTo', 'invalid args');
      }

      if (!this.checkVersion(pathObject)) {
        return fail('navigateTo', 'version are not compatible in smp');
      }

      if (!this.checkParams(pathObject)) {
        return fail('navigateTo', 'params are not compatible');
      }

      var apiName = options && options.apiName || 'navigateTo';
      var routerObject = this.getRouterObject(pathObject);
      if (!routerObject.path) return fail(apiName, 'no path found');
      if (routerObject.path === 'unsupported') return fail(apiName, 'unsupported in smp');
      var redirect = options && options.redirect || false;
      var escapeParams = options && options.escapeParams || {};
      var link = this.appendRefer(this.appendParams(pathReplace(routerObject.path, pathObject), escapeParams));
      onNavigateTo();

      if (routerObject.isTab) {
        loadWxJssdk.then(function () {
          fakeWindow.wx.miniProgram.switchTab({
            url: link
          });
        });
      } else if (redirect) {
        loadWxJssdk.then(function () {
          fakeWindow.wx.miniProgram.redirectTo({
            url: link
          });
        });
      } else {
        loadWxJssdk.then(function () {
          fakeWindow.wx.miniProgram.navigateTo({
            url: link
          });
        });
      }

      return apiInvokeSuccess(apiName);
    }
  }, {
    key: "canNavigateTo",
    value: function canNavigateTo(pathObject) {
      if (typeof pathObject === 'string') {
        return this.canLinkTo(pathObject);
      }

      if (!this.checkPathObject(pathObject) || !this.checkVersion(pathObject)) {
        return apiInvokeSuccess('canNavigateTo', false);
      }

      return apiInvokeSuccess('canNavigateTo', true);
    }
  }, {
    key: "navigateBack",
    value: function navigateBack() {
      var backNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      if (backNum <= 0) {
        return fail('navigateBack', ' backNum only accepts positive number');
      }

      loadWxJssdk.then(function () {
        fakeWindow.wx.miniProgram.navigateBack({
          delta: backNum
        });
      });
      return apiInvokeSuccess('navigateBack', true);
    }
  }]);

  return SmpRouter;
}(BaseRouter);
var smpRouter = new SmpRouter();

/**
 * @description webBridge的具体实现
 */

var bridge$3 = new Bridge();
bridge$3.registerPoster(function (name, params, cb1, cb2) {
  /* iframe or spa */
  if (fakeWindow !== fakeWindow.parent || fakeWindow.__IKEACN__) {
    /**
     * @param type 类型
     * @param name 要运行的方法名
     * @param params 所需要的参数
     * @param cb1 成功回调函数名
     * @param cb2 失败回调函数名
     */
    (fakeWindow.__IKEACN__ ? fakeWindow : fakeWindow.parent).postMessage({
      type: 'sdk',
      name: name,
      params: params,
      cb1: cb1,
      cb2: cb2
    }, '*');
    return;
  }
  /* 无bridge */


  fakeWindow.jsBridge[cb2]({
    message: 'no bridge found'
  });
});
bridge$3.registerReceiver(function () {
  /* iframe or spa */
  if (fakeWindow !== fakeWindow.parent || fakeWindow.__IKEACN__) {
    /**
     * @param event.data.type 类型，sdk
     * @param event.data.value 返回数据
     * @param event.data.message 返回消息
     * @param event.data.name 返回调用回调
     */
    fakeWindow.addEventListener('message', function (event) {
      if (!event.data || event.data.type !== 'sdk') {
        return;
      }

      if (event.data) {
        var _event$data = event.data,
            value = _event$data.value,
            message = _event$data.message,
            name = _event$data.name;

        if (!name || !fakeWindow.jsBridge[name]) {
          throw new Error('未找到相应的回调函数');
        }

        fakeWindow.jsBridge[name]({
          message: message,
          value: value
        });
      }
    });
  }
});

var WebRouter = /*#__PURE__*/function (_BaseRouter) {
  _inherits(WebRouter, _BaseRouter);

  var _super = _createSuper(WebRouter);

  function WebRouter() {
    _classCallCheck$1(this, WebRouter);

    return _super.apply(this, arguments);
  }

  _createClass$1(WebRouter, [{
    key: "navigateTo",
    value: function navigateTo(pathObject, options) {
      if (typeof pathObject === 'string') {
        return this.linkTo(pathObject, options);
      }

      if (!this.checkPathObject(pathObject)) {
        return fail('navigateTo', 'invalid args');
      }

      if (!this.checkVersion(pathObject)) {
        return fail('navigateTo', 'version are not compatible in web');
      }

      if (!this.checkParams(pathObject)) {
        return fail('navigateTo', 'params are not compatible');
      }

      var apiName = (options === null || options === void 0 ? void 0 : options.apiName) || 'navigateTo';
      var routerObject = this.getRouterObject(pathObject);
      if (!routerObject.visitPath) return fail(apiName, 'no visitPath found');
      if (routerObject.visitPath === 'unsupported') return fail(apiName, 'unsupported in web');
      var redirect = (options === null || options === void 0 ? void 0 : options.redirect) || false;
      var newTab = (options === null || options === void 0 ? void 0 : options.newTab) === undefined ? true : options.newTab;
      var escapeParams = (options === null || options === void 0 ? void 0 : options.escapeParams) || {};
      var href = '';

      if (isLocal && routerObject.localPath) {
        /* 本地环境的跳转以local配置为主 */
        href = this.appendRefer(this.appendParams(pathReplace(routerObject.localPath, pathObject), escapeParams));
      } else if (fakeWindow !== fakeWindow.parent || fakeWindow.__IKEACN__) {
        /* iframe or spa */
        return bridge$3.call(apiName, 'navigateTo', {
          path: this.appendRefer(this.appendParams(pathReplace(routerObject.visitPath, pathObject), escapeParams)),
          redirect: redirect,
          newTab: newTab
        });
      } else if (routerObject.path) {
        /* cdn接入 & 存在cdn路径，直接跳cdn地址 */
        href = this.appendRefer(this.appendParams(pathReplace(routerObject.path, pathObject), escapeParams));
        /* 非http链接会被视为res的相对路径 */

        if (!isHttp(href)) {
          href = getResHost() + href;
        }
      } else {
        /* cdn接入 & 不存在cdn路径，跳官网相应地址 */
        var path = pathReplace(routerObject.visitPath, pathObject);
        var lang = '/cn/' + currentLanguage$1();
        href = webHost() + lang + this.appendRefer(this.appendParams(path, escapeParams));
      }

      var agent = getWebviewAgent();

      if (redirect) {
        location.replace(href);
      } else if (newTab && !['wechat_mobile', 'wechat_pc'].includes(agent) && !/^((?!chrome|android).)*safari/i.test(fakeWindow.navigator.userAgent)) {
        /**
         * 微信环境不以open形式打开新页面
         * safari对window.open指出不友好，故不使用window.open
         */
        fakeWindow.open(href);
      } else {
        location.href = href;
      }

      return apiInvokeSuccess(apiName);
    }
  }, {
    key: "canNavigateTo",
    value: function canNavigateTo(pathObject) {
      if (typeof pathObject === 'string') {
        return this.canLinkTo(pathObject);
      }

      if (!this.checkPathObject(pathObject) || !this.checkVersion(pathObject)) {
        return apiInvokeSuccess('canNavigateTo', false);
      }

      return apiInvokeSuccess('canNavigateTo', true);
    }
  }, {
    key: "navigateBack",
    value: function navigateBack() {
      var backNum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      if (backNum <= 0) {
        return fail('navigateBack', ' backNum only accepts positive number');
      }

      fakeWindow.history.go(-backNum);
      return apiInvokeSuccess('navigateBack', true);
    }
  }, {
    key: "goToPayment",
    value: function goToPayment(options) {
      var checkoutId = options.checkoutId,
          checkoutType = options.checkoutType,
          autoRedirect = options.autoRedirect;
      var redirectRoute = _typeof(options.redirectRoute) === 'object' ? encodeURIComponent(JSON.stringify(options.redirectRoute)) : typeof options.redirectRoute === 'string' ? encodeURIComponent(options.redirectRoute) : null;
      var params = "?id=".concat(checkoutId).concat(checkoutType ? "&checkoutType=".concat(checkoutType) : '').concat(redirectRoute ? "&redirectRoute=".concat(redirectRoute) : '').concat(autoRedirect ? "&autoRedirect=".concat(autoRedirect) : '');
      /* 官网环境下，走postMessage */

      return bridge$3.call('goToPayment', 'navigateTo', {
        path: '/pay/checkstand'.concat(params),
        redirect: redirectRoute
      });
    }
  }]);

  return WebRouter;
}(BaseRouter);

var webRouter = new WebRouter();

var bridge$2 = new Bridge();
/**
 * @description harmonyBridge的具体实现
 * callNativeAPI的错误/正确回调都是同一个方法，目前自己实现的bridge方法可以通过responseType去做区分
 * 但是finclip自己的方法无法区分，统一都走success
 */

bridge$2.registerPoster(function (name, params, cb1, cb2) {
  loadWxJssdk.then(function () {
    /**
     * harmonyBridge有两套运行逻辑
     * 1. name以ft_开头的走finclip的bridge逻辑
     * 2. name不以ft_开头的走webBridge逻辑
     */
    if (name.startsWith('ft_')) {
      fakeWindow.wx.callNativeAPI(name.slice(3), params, function (res) {
        fakeWindow.jsBridge[cb1](res);
      });
    } else {
      fakeWindow.wx.callNativeAPI('webBridge', {
        apiName: name,
        params: params
      }, function (res) {
        if (res.responseType === 'fail') {
          fakeWindow.jsBridge[cb2](res);
        } else {
          fakeWindow.jsBridge[cb1](res);
        }
      });
    }
  });
});

var HarmonyRouter = /*#__PURE__*/function (_SmpRouter) {
  _inherits(HarmonyRouter, _SmpRouter);

  var _super = _createSuper(HarmonyRouter);

  function HarmonyRouter() {
    _classCallCheck$1(this, HarmonyRouter);

    return _super.apply(this, arguments);
  }

  _createClass$1(HarmonyRouter, [{
    key: "navigateTo",
    value: function navigateTo(pathObject, options) {
      if (typeof pathObject === 'string') {
        return this.linkTo(pathObject, options);
      }

      if (!this.checkPathObject(pathObject)) {
        return fail('navigateTo', 'invalid args');
      }

      if (!this.checkVersion(pathObject)) {
        return fail('navigateTo', 'version are not compatible in harmony');
      }

      if (!this.checkParams(pathObject)) {
        return fail('navigateTo', 'params are not compatible');
      }

      var apiName = options && options.apiName || 'navigateTo';
      var routerObject = this.getRouterObject(pathObject);
      if (!routerObject.path) return fail(apiName, 'no path found');
      if (routerObject.path === 'unsupported') return fail(apiName, 'unsupported in harmony');
      var redirect = options && options.redirect || false;
      var escapeParams = options && options.escapeParams || {};
      var link = this.appendRefer(this.appendParams(pathReplace(routerObject.path, pathObject), escapeParams));
      onNavigateTo();

      if (link.startsWith('native://')) {
        /* harmony://link格式表示走鸿蒙原生地址 */
        var native_link = link.replace('native://', '');
        bridge$2.call(apiName, 'push', {
          url: native_link,
          redirect: redirect
        });
      } else {
        /* 默认走小程序地址 */
        if (routerObject.isTab) {
          loadWxJssdk.then(function () {
            fakeWindow.wx.miniProgram.switchTab({
              url: link
            });
          });
        } else if (redirect) {
          loadWxJssdk.then(function () {
            fakeWindow.wx.miniProgram.redirectTo({
              url: link
            });
          });
        } else {
          loadWxJssdk.then(function () {
            fakeWindow.wx.miniProgram.navigateTo({
              url: link
            });
          });
        }
      }

      return apiInvokeSuccess(apiName);
    }
  }]);

  return HarmonyRouter;
}(SmpRouter);

var harmonyRouter = new HarmonyRouter();

var router = channelFilter('router', {
  app: appRouter,
  smp: smpRouter,
  web: webRouter,
  harmony: harmonyRouter
});

/* 运行WxJssdk */

var invoke = function invoke(apiName, api, options) {
  /* 保证wxJssdk加载完毕 */
  return initWxJssdk().then(function () {
    var _getPromise = getPromise(),
        promise = _getPromise.promise,
        res = _getPromise.res,
        rej = _getPromise.rej;
    /* 运行wxApi */


    fakeWindow.wx[api](_objectSpread2(_objectSpread2({}, options), {}, {
      success: function success(_res) {
        return res(apiInvokeSuccess(apiName, _res));
      },
      fail: function fail(e) {
        return rej("".concat(api, "\u8C03\u7528\u5931\u8D25").concat(JSON.stringify(e)));
      },
      cancel: function cancel(e) {
        return rej("".concat(api, "\u6388\u6743\u5931\u8D25").concat(JSON.stringify(e)));
      }
    }));
    return promise;
  })["catch"](function (msg) {
    return fail(apiName, msg);
  });
};

/* 展示/关闭loading单例 */
var LoadingFactory = /*#__PURE__*/function () {
  function LoadingFactory() {
    _classCallCheck$1(this, LoadingFactory);

    _defineProperty(this, "node", void 0);

    _defineProperty(this, "style", void 0);

    _defineProperty(this, "isLoading", false);

    /* 创建loading元素 */
    var loading = document.createElement('div');
    loading.id = 'ikea-jssdk-loading-container';
    loading.style.display = 'flex';
    loading.innerHTML = "\n      <div class=\"ikea-jssdk-loading\">\n        <div class=\"ikea-jssdk-loading__icon\">\n          <span class=\"ikea-jssdk-loading__ball\" aria-hidden=\"\" type=\"Ball\" color=\"#111\"></span>\n        </div>\n      </div>\n    ";
    this.node = loading;
    /* 创建样式 */

    this.style = document.createElement('style');
    this.style.innerHTML = "\n      #ikea-jssdk-loading-container {\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        top: 0px;\n        left: 0px;\n        display: none;\n        justify-content: center;\n        z-index: 1;\n      }\n\n      .ikea-jssdk-loading {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .ikea-jssdk-loading__icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n      }\n\n      .ikea-jssdk-loading__ball {\n        display: block;\n        width: 0.5rem;\n        height: 0.5rem;\n        background: #0058a3;\n        border-radius: 64px;\n        transform-origin: bottom;\n        transition: opacity .2s cubic-bezier(.4, 0, .4, 1);\n        animation: ikea-jssdk-loading-bounce .7s infinite;\n      }\n\n      @keyframes ikea-jssdk-loading-bounce {\n        0%,\n        100% {\n          transform: translate(50%, -160%);\n          animation-timing-function: cubic-bezier(.42, 0, 1, 1);\n        }\n\n        40% {\n          transform: translate(50%, 20%);\n          animation-timing-function: cubic-bezier(0, 0, 0, 1);\n        }\n      }\n    ";
  }

  _createClass$1(LoadingFactory, [{
    key: "openLoading",
    value: function openLoading() {
      /* 插入body */
      if (!this.isLoading) {
        document.body.appendChild(this.style);
        document.body.appendChild(this.node);
      }

      this.isLoading = true;
    }
  }, {
    key: "closeLoading",
    value: function closeLoading() {
      /* 删除body */
      if (this.isLoading) {
        document.body.removeChild(this.style);
        document.body.removeChild(this.node);
      }

      this.isLoading = false;
    }
  }]);

  return LoadingFactory;
}();

_defineProperty(LoadingFactory, "loading", new LoadingFactory());

/**
 * Growing io config
 */
var GIOConfig = /*#__PURE__*/function () {
  /**
   * 广告来源
   * @type {string}
   */

  /**
   * 广告媒介
   * @type {string}
   */

  /**
   * 广告名称
   * @type {string}
   */

  /**
   * 广告内容
   * @type {string}
   */

  /**
   * 广告关键词
   * @type {string}
   */
  function GIOConfig(config) {
    _classCallCheck$1(this, GIOConfig);

    _defineProperty(this, "utm_source", void 0);

    _defineProperty(this, "utm_medium", void 0);

    _defineProperty(this, "utm_campaign", void 0);

    _defineProperty(this, "utm_content", void 0);

    _defineProperty(this, "utm_term", void 0);

    this.utm_source = config && config.utm_source || '';
    this.utm_medium = config && config.utm_medium || '';
    this.utm_campaign = config && config.utm_campaign || '';
    this.utm_content = config && config.utm_content || '';
    this.utm_term = config && config.utm_term || '';
  }

  _createClass$1(GIOConfig, [{
    key: "toString",
    value: function toString() {
      var str = '';
      str += (this.utm_source ? "utm_source=".concat(this.utm_source, "&") : '') + (this.utm_medium ? "utm_medium=".concat(this.utm_medium, "&") : '') + (this.utm_campaign ? "utm_campaign=".concat(this.utm_campaign, "&") : '') + (this.utm_content ? "utm_content=".concat(this.utm_content, "&") : '') + (this.utm_term ? "utm_term=".concat(this.utm_term, "&") : '');
      if (str.length > 1) str = str.substr(0, str.length - 1);
      return str;
    }
  }]);

  return GIOConfig;
}();

/**
 * @description 初始化sdk
 * @param isDebug 可选，true会使用qa接口
 * @param refer 可选，路由跳转来源方
 * @param prerender 可选，sdk是否在预渲染模式中使用，在预渲染模式下会调整部分js加载逻辑
 * @param unauthorizationHandler 可选，401报错处理函数
 * @param backendTrackingParams 可选，用于后端埋点的参数
 * @param wxAppId 可选，用于wxsdk初始化的appId
 */

var init = function init(options) {
  if (options !== null && options !== void 0 && options.isDebug) {
    setDebug(options.isDebug);
  }

  if (options !== null && options !== void 0 && options.env) {
    setEnv(options.env);
  }

  if (options !== null && options !== void 0 && options.refer) {
    setRefer(options.refer);
  }

  if (options !== null && options !== void 0 && options.prerender) {
    setPrerender(options.prerender);
  }

  if (options !== null && options !== void 0 && options.unauthorizationHandler) {
    setUnauthorizationHandler(options.unauthorizationHandler);
  }

  if (options !== null && options !== void 0 && options.backendTrackingParams) {
    setBackendTrackingParams(options.backendTrackingParams);
  }
};
/**
 * @description 获取平台信息
 */

var getCurrentPlatform = function getCurrentPlatform() {
  var value = getCurrentPlatform$1();

  return apiInvokeSuccess('getCurrentPlatform', value);
};
/**
 * @description 获取deviceId
 */

var getDeviceId = function getDeviceId() {
  var value = getDeviceId$1();

  return apiInvokeSuccess('getDeviceId', value);
};
/**
 * @description 获取deviceModel
 */

var getDeviceModel = function getDeviceModel() {
  var value = getDeviceModel$1();

  return apiInvokeSuccess('getDeviceModel', value);
};
/**
 * @description 获取osVersion
 */

var getOsVersion = function getOsVersion() {
  var value = getOsVersion$1();

  return apiInvokeSuccess('getOsVersion', value);
};
/**
 * @description 获取osVersion
 */

var getZipcode = function getZipcode() {
  var value = getZipcode$1();

  return apiInvokeSuccess('getZipcode', value);
};
/**
 * @description 获取sessionId
 */

var getSessionId = function getSessionId() {
  var value = getSessionId$1();

  return apiInvokeSuccess('getSessionId', value);
};
/**
 * @description 获取位置信息 
 */

var getAddressInfo = channelFilter('getAddressInfo', {
  app: function app() {
    return bridge$4.call('getAddressInfo', 'getCity');
  },
  smp: function smp() {
    try {
      var addressInfo = JSON.parse(decodeURIComponent(getAddressInfo$1()));
      return apiInvokeSuccess('getAddressInfo', addressInfo);
    } catch (_unused) {
      return fail('getAddressInfo', "parsing error: ".concat(getAddressInfo$1()));
    }
  }
});
/**
 * @description 获取经纬度信息 
 */

var getLocation = channelFilter('getLocation', {
  app: function () {
    var _app = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var hasLocationPermission, status;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!compareVersion('>=3.29.0')) {
                _context.next = 10;
                break;
              }

              _context.next = 3;
              return bridge$4.call('getLocationPermission', 'getLocationPermission');

            case 3:
              hasLocationPermission = _context.sent.value;
              status = hasLocationPermission === null || hasLocationPermission === void 0 ? void 0 : hasLocationPermission.permissionStatus;

              if (!(status === 0 || status >= 3)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", bridge$4.call('getLocation', 'getLocation'));

            case 9:
              return _context.abrupt("return", fail('getLocation', 'permission denied'));

            case 10:
              return _context.abrupt("return", bridge$4.call('getLocation', 'getLocation'));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function app() {
      return _app.apply(this, arguments);
    }

    return app;
  }(),
  smp: function smp() {
    return invoke('getLocation', 'getLocation');
  },
  harmony: function harmony() {
    return bridge$2.call('getLocation', 'ft_getLocation');
  }
});
/**
 * @description 打开appStore （iOS会跳转至apple Store，Android跳转至应用市场）
 */

var goToAppStore = channelFilter('goToAppStore', {
  app: versionFn('>=2.28.0', 'app', function () {
    return bridge$4.call('goToAppStore', 'goToAppStore');
  }, 'goToAppStore'),
  harmony: function harmony() {
    return bridge$2.call('goToAppStore', 'goToAppStore');
  }
});
/**
 * @description 获取通用链接
 * suitable for H5 link
 * @param h5Link h5链接
 * @param gioConfig gio配置
 * @param nativeParams 拼接在webview的参数
 * @param univeralLink ikea通用链接
 */

var generateLink = function generateLink(options) {
  var h5Link = options && options.h5Link || location.href;
  var nativeParams = options && options.nativeParams || {};
  var rawLink = (options === null || options === void 0 ? void 0 : options.universalLink) || "https://ikeaapp/web?url=".concat(encodeURIComponent(h5Link));
  var link = "".concat(getResHost(), "/page/qr.html?url=").concat(encodeURIComponent(appendParams(rawLink, nativeParams)));

  if (options && options.gioConfig) {
    var config = new GIOConfig(options.gioConfig);

    if (config.toString()) {
      link = "".concat(getResHost(), "/page/qr.html?").concat(config.toString(), "&url=").concat(encodeURIComponent(appendParams(rawLink, nativeParams)));
    }
  }

  return apiInvokeSuccess('generateLink', link);
};
/**
 * @description 增加app右上角按钮
 * @param buttons button数组，可以配置icon或者文案，如果两者都配置，优先展示icon
 */

var addNavigationActions = channelFilter('addNavigationActions', {
  app: versionFn('>=2.0.0', 'app', function (buttons) {
    return bridge$4.call('addNavigationActions', 'navigationActions', buttons);
  }, 'addNavigationActions')
});
/**
 * @description 打开地图
 */

var openMap = channelFilter('openMap', {
  app: versionFn('>=2.0.0', 'app', function (options) {
    var opt = trans2Object(options);
    var latitude = parseFloat(opt.latitude);
    var longitude = parseFloat(opt.longitude);
    location.href = "https://ikeaapp/openMap?name=".concat(opt.name, "&latitude=").concat(latitude, "&longitude=").concat(longitude);
    return apiInvokeSuccess('openMap');
  }, 'openMap'),
  smp: function smp(options) {
    var opt = trans2Object(options);
    var latitude = parseFloat(opt.latitude);
    var longitude = parseFloat(opt.longitude);
    return invoke('openMap', 'openLocation', _objectSpread2(_objectSpread2({}, opt), {}, {
      latitude: latitude,
      longitude: longitude
    }));
  },
  harmony: function harmony(options) {
    var opt = trans2Object(options);
    var latitude = parseFloat(opt.latitude);
    var longitude = parseFloat(opt.longitude);
    return bridge$2.call('openMap', 'openMap', _objectSpread2(_objectSpread2({}, opt), {}, {
      latitude: latitude,
      longitude: longitude
    }));
  }
});
/**
 * @description 获取当前语言
 */

var currentLanguage = function currentLanguage() {
  var lang = currentLanguage$1();

  return apiInvokeSuccess('currentLanguage', lang);
};
/**
 * @description 调用微信sdk
 */

var invokeWxsdk = channelFilter('invokeWxsdk', {
  smp: function smp(api, options) {
    return invoke('invokeWxsdk', api, options);
  },
  web: function web(api, options) {
    return invoke('invokeWxsdk', api, options);
  }
});
/**
 * @description 用户是否已经授权通知权限
 */

var getNotificationPermission = channelFilter('getNotificationPermission', {
  app: function app() {
    return bridge$4.call('getNotificationSetting', 'getNotificationSetting').then(function (res) {
      var _res$value;

      return apiInvokeSuccess('getNotificationPermission', (_res$value = res.value) === null || _res$value === void 0 ? void 0 : _res$value.auth);
    });
  }
});
/**
 * @description 去系统设置中心更改通知权限，客户端负责刷新
 */

var openSetting = channelFilter('openSetting', {
  app: function app() {
    return bridge$4.call('openSetting', 'openSetting');
  },
  harmony: function harmony() {
    return bridge$2.call('openSetting', 'ft_openAppAuthorizeSetting');
  }
});
/* loading控制 */

var openLoading = channelFilter('openLoading', {
  app: function app() {
    if (compareVersion('>=3.34.0') && parseURL(location.href).params.needsNativeLoading === 'true') {
      return bridge$4.call('openLoading', 'openNativeLoading');
    } else {
      LoadingFactory.loading.openLoading();
      return apiInvokeSuccess('openLoading');
    }
  },
  smp: function smp() {
    LoadingFactory.loading.openLoading();
    return apiInvokeSuccess('openLoading');
  },
  web: function web() {
    LoadingFactory.loading.openLoading();
    return apiInvokeSuccess('openLoading');
  }
});
var closeLoading = channelFilter('closeLoading', {
  app: function app() {
    if (compareVersion('>=3.34.0') && parseURL(location.href).params.needsNativeLoading === 'true') {
      return bridge$4.call('closeLoading', 'endNativeLoading');
    } else {
      LoadingFactory.loading.closeLoading();
      return apiInvokeSuccess('closeLoading');
    }
  },
  smp: function smp() {
    LoadingFactory.loading.closeLoading();
    return apiInvokeSuccess('closeLoading');
  },
  web: function web() {
    LoadingFactory.loading.closeLoading();
    return apiInvokeSuccess('closeLoading');
  }
});
/**
 * @description 调用扫码功能 
 * @param options: needResult默认为false，扫描结果由app或小程序自己处理，true则直接返回扫描结果，
 * @returns {"result": "123456"} 如果失败 {"result": null}
 */

var scanCode = channelFilter('scanCode', {
  app: versionFn('>=3.39.0', 'app', function (options) {
    var _options$needResult;

    return bridge$4.call('scanCode', 'scanCode', {
      'needHandleResult': (_options$needResult = options.needResult) !== null && _options$needResult !== void 0 ? _options$needResult : false
    });
  }, 'scanCode'),
  smp: function () {
    var _smp = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(options) {
      var result;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return invoke('scanCode', 'scanQRCode', {
                'needResult': options.needResult == true ? 1 : 0
              });

            case 2:
              result = _context2.sent.value;

              if (!result.resultStr) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", apiInvokeSuccess('scanCode', {
                result: result.resultStr
              }));

            case 7:
              return _context2.abrupt("return", fail('scanCode', 'scan failed'));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function smp(_x) {
      return _smp.apply(this, arguments);
    }

    return smp;
  }()
});
/**
 * @description 获取APP的preference存储
 */

var getSharePrefereceData = channelFilter('getSharePrefereceData', {
  app: versionFn('>=3.39.0', 'app', function () {
    return bridge$4.call('getSharePrefereceData', 'getSharePrefereceData');
  }, 'scanCode')
});

var bridge$1 = new Bridge();
/**
 * @description smpBridge的具体实现
 * @warn smp的通信是单向的
 */

bridge$1.registerPoster(function (_name, params, cb1) {
  loadWxJssdk.then(function () {
    fakeWindow.wx.miniProgram.postMessage({
      data: params
    });
  });
  fakeWindow.jsBridge[cb1]();
});

/**
 * @description web和smp的事件
 * 在smp和web，部分事件无法通过原生端触发，需要在jssdk内部进行自我判断&触发
 */

/** 
 * onShow 当页面被展示的时候触发
 */

var onSmpShow = runOnce(function () {
  var nav = false;
  var show = true;

  fakeWindow.jsBridge.onNavigateTo = function () {
    nav = true;
  };

  document.addEventListener('visibilitychange', function (e) {
    var visibility = e.target.visibilityState;
    if (visibility === 'hidden') show = false;
    if (visibility === 'visible') show = true;

    if (show && nav) {
      nav = false;
      fakeWindow.jsBridge.onShow && fakeWindow.jsBridge.onShow();
    }
  });
});
var onHarmonyShow = runOnce(function () {
  loadWxJssdk.then(function () {
    fakeWindow.wx.miniProgram.onShow(function () {
      fakeWindow.jsBridge.onShow && fakeWindow.jsBridge.onShow();
    });
  });
});
/**
 * @description smp事件
 */

var initSmpEvents = function initSmpEvents() {
  onSmpShow();
};
/**
 * @description harmony事件
 */

var initHarmonyEvents = function initHarmonyEvents() {
  onHarmonyShow();
};

var bridge = channelFilter('bridge', {
  app: bridge$4,
  smp: bridge$1,
  web: bridge$3,
  harmony: bridge$2
}, {
  smp: initSmpEvents,
  harmony: initHarmonyEvents
});

/**
 * @description 获取端上的token
 */

var getDeviceToken = function getDeviceToken() {
  return Promise.race([bridge.call('fetchDeviceToken', 'fetchDeviceToken').then(function (res) {
    var token = res.value;
    /* app环境 */

    if (token && token['X-RCDeviceToken']) {
      return {
        'X-RCDeviceToken': token['X-RCDeviceToken']
      };
    }
    /* web环境 */


    if (token && token.value) {
      var webToken = token.value;

      if (webToken.uaToken && webToken.webUmidToken) {
        return {
          'X-RCUaToken': webToken.uaToken,
          'X-RCWebUmidToken': webToken.webUmidToken
        };
      }
    }

    return {};
  }), new Promise(function (res) {
    setTimeout(function () {
      res({});
    }, 500);
  })]);
};
/**
 * @description 获取通用headers
 */

var getCommonHeaders = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(withToken, mockToken, includeRiskControlHeaders) {
    var languageMap, lang, headers, tokens, backendTrackingParams, pageId, pageName, pageType;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            languageMap = {
              zh: 'zh-CN',
              en: 'en-US'
            };
            lang = currentLanguage$1();
            headers = {
              'content-type': 'application/json',
              'Accept-Language': languageMap[lang] || lang,
              'X-Client-Platform': getPlatform(),
              'X-Client-Version': getClientVersion(),
              'X-Client-DeviceId': getDeviceId$1(),
              'X-Client-DeviceModel': getDeviceModel$1(),
              'X-Client-OSVersion': getOsVersion$1(),
              'X-Client-Personalized': getPersonalized(),
              'X-Client-Zipcode': getZipcode$1(),
              'X-Client-City': getCity(),
              'X-Client-SessionId': getSessionId$1() || '',
              'X-Client-Render': 'jssdk'
            };

            if (getToken$1() && withToken) {
              headers['Authorization'] = "Bearer ".concat(getToken$1());
            }

            if (!includeRiskControlHeaders) {
              _context.next = 9;
              break;
            }

            _context.next = 7;
            return getDeviceToken();

          case 7:
            tokens = _context.sent;
            headers = _objectSpread2(_objectSpread2({}, tokens), headers);

          case 9:
            if (mockToken) {
              headers['Authorization'] = "Bearer ".concat(mockToken);
            }

            backendTrackingParams = getBackendTrackingParams();
            pageId = backendTrackingParams.pageId, pageName = backendTrackingParams.pageName, pageType = backendTrackingParams.pageType;

            if (pageType) {
              headers['x-client-source'] = encodeURIComponent(pageType);
            }

            if (pageId) {
              headers['x-client-sourceid'] = encodeURIComponent(pageId);
            }

            if (pageName) {
              headers['x-client-sourcename'] = encodeURIComponent(pageName);
            }

            return _context.abrupt("return", headers);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCommonHeaders(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @description 判断url是否符合条件
 */

var match = function match(entity, url) {
  if (typeof entity === 'boolean') return entity;
  if (!url) return false;

  try {
    return entity.some(function (reg) {
      return reg.test(url);
    });
  } catch (_unused) {
    return false;
  }
};
var getValue = function getValue(value, defaultValue) {
  if (value === undefined) return defaultValue;
  return value;
};

var axiosPlugin = (function (axios) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  axios.interceptors.request.use( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(config) {
      var withToken, includeRiskControlHeaders, headers;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              withToken = getValue(options.withToken, true);
              includeRiskControlHeaders = getValue(options.includeRiskControlHeaders, true);
              headers = getValue(options.headers, {});

              if (!config.baseURL) {
                config.baseURL = getMBFFHost();
              }

              _context.t0 = merge;
              _context.t1 = {};
              _context.next = 8;
              return getCommonHeaders(match(withToken, config.url), undefined, match(includeRiskControlHeaders, config.url));

            case 8:
              _context.t2 = _context.sent;
              _context.t3 = headers;
              _context.t4 = config.headers || {};
              config.headers = (0, _context.t0)(_context.t1, _context.t2, _context.t3, _context.t4);
              return _context.abrupt("return", config);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
});

/**
 * @description 接口请求方法
 * @param options.baseURL 默认地址
 * @param options.path 请求地址
 * @param options.method 请求方法
 * @param options.data 请求体数据
 * @param options.params 请求地址参数
 * @param options.headers 请求头
 * @param options.withToken 请求是否携带token
 * @param options.mockToken 模拟token
 * @param options.includeRiskControlHeaders 是否需要风控头
 * @param options.cache 是否开启缓存
 */

var request = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(options) {
    var _merge, baseURL, path, method, data, params, headers, _merge$withToken, withToken, mockToken, body, includeRiskControlHeaders, _merge$cache, cache, config, zipCode, url;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _merge = merge({}, defaultOptions, options), baseURL = _merge.baseURL, path = _merge.path, method = _merge.method, data = _merge.data, params = _merge.params, headers = _merge.headers, _merge$withToken = _merge.withToken, withToken = _merge$withToken === void 0 ? true : _merge$withToken, mockToken = _merge.mockToken, body = _merge.body, includeRiskControlHeaders = _merge.includeRiskControlHeaders, _merge$cache = _merge.cache, cache = _merge$cache === void 0 ? false : _merge$cache;
            /* headers配置 */

            config = {};
            _context.t0 = _objectSpread2;
            _context.t1 = _objectSpread2;
            _context.t2 = {};
            _context.next = 7;
            return getCommonHeaders(withToken, mockToken, includeRiskControlHeaders);

          case 7:
            _context.t3 = _context.sent;
            _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
            _context.t5 = headers;
            config.headers = (0, _context.t0)(_context.t4, _context.t5);

            /* 去除无效header */
            config.headers = JSON.parse(JSON.stringify(config.headers));
            /* method处理 */

            config.method = method;
            /**
             * zipcode处理
             */

            zipCode = getZipcode$1();

            if ((method === 'GET' || method === 'get') && params && zipCode) {
              params.zipCode = zipCode;
            }
            /* 地址处理 */


            url = (baseURL || getMBFFHost()) + appendParams(path, params);
            /* body处理 */

            if (data) {
              config.body = JSON.stringify(data);
            } else if (body) {
              config.body = body;
            }
            /* cors处理 */


            if (method === 'GET' || method === 'get') {
              config.mode = 'cors';
            }
            /*
             * 缓存处理
             * 目前仅get方法支持缓存
             */


            if (!(cache && (method === 'GET' || method === 'get'))) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", singleton(url, function () {
              return fetch(url, config).then(function (response) {
                return handleResponse(response);
              });
            }, function (res) {
              return res.then(function () {
                return false;
              })["catch"](function () {
                return true;
              });
            }));

          case 22:
            return _context.abrupt("return", fetch(url, config).then(function (response) {
              return handleResponse(response);
            }));

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function request(_x) {
    return _ref.apply(this, arguments);
  };
}();

var handleResponse = function handleResponse(response) {
  var unauthorizationHandler = getUnauthorizationHandler();

  if (!response.ok && response.status === 401 && unauthorizationHandler) {
    unauthorizationHandler();
  }

  var res = {
    status: response.status
  };
  return response.json().then(function (data) {
    res.data = data;

    if (response.ok) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  })["catch"](function (_e) {
    if (response.ok) {
      return Promise.resolve(res);
    }

    res.data = res.data || {
      message: 'network error'
    };
    return Promise.reject(res);
  });
};
/* options初始化 */


var defaultOptions = {};

request.init = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = options;
};
/* axios plugin */


request.axiosPlugin = axiosPlugin;
/* 预先封装请求 */

/**
 * @description 加购接口
 * @param { data.products } array 加购商品
 * @param { data.products[].productFullId } string 加购商品id
 * @param { data.products[].quantity } number 加购商品数量
 */

request.addToCart = function (data) {
  return request({
    path: '/shopping/cart/v3/add-to-cart',
    method: 'POST',
    data: data
  });
};

/**
 * @description 是否登录
 */

var isLogin = function isLogin() {
  var value = isLogin$1();

  return apiInvokeSuccess('isLogin', value);
};
/**
 * @description 获取token
 */

var getToken = function getToken() {
  var token = getToken$1();

  return apiInvokeSuccess('getToken', token || '');
};
/**
 * @description 获取用户信息
 */

var getUserInfo = function getUserInfo() {
  return request({
    path: '/accounts/me',
    method: 'GET',
    withToken: true
  }).then(function (response) {
    return apiInvokeSuccess('getUserInfo', response.data || '');
  })["catch"](function () {
    return fail('getUserInfo', 'fail to get userInfo');
  });
};

/**
 * @description api版本信息
 * 版本号 '>=2.0.0' 表示版本>=2.0.0的版本支持
 * true 表示该平台支持
 */
var messageApiConfig = {
  refreshShoppingCart: {
    app: '>=2.12.0',
    smp: true
  },
  setShareOptions: {
    smp: true
  },
  familyRegisterSuccess: {
    app: '>=3.1.0',
    smp: true,
    web: true
  },
  refreshAccountInfo: {
    app: '>=3.2.0'
  }
};
/**
 * @description 判断但前post api是否是版本支持
 */

var checkApiConfig = function checkApiConfig(name, type) {
  if (!messageApiConfig[name]) {
    return fail('postMessage', "invalid message name ".concat(name));
  }

  var version = messageApiConfig[name][type];

  if (version === undefined) {
    return fail('postMessage', "".concat(name, " is not supported in ").concat(type));
  }

  if (version === true) return;

  if (version && !checkVersion(getClientVersion(), version)) {
    return fail('postMessage', "".concat(name, " is not supported for the version ").concat(version, " in ").concat(type));
  }
};
/**
 * @description 消息通信基类
 * @function post 传递消息
 */


var Message = function Message() {
  _classCallCheck$1(this, Message);

  _defineProperty(this, "checkApiConfig", checkApiConfig);
};

var _dec$1, _class$1;
/**
 * Todo: postMessage 版本支持需要定下来
 */

var AppMessage = (_dec$1 = version$1('>=2.0.0', 'app'), (_class$1 = /*#__PURE__*/function (_Message) {
  _inherits(AppMessage, _Message);

  var _super = _createSuper(AppMessage);

  function AppMessage() {
    _classCallCheck$1(this, AppMessage);

    return _super.apply(this, arguments);
  }

  _createClass$1(AppMessage, [{
    key: "postMessage",
    value: function postMessage(event) {
      var name = event.name;
      var result = this.checkApiConfig(name, 'app');
      if (result) return result;
      return bridge$4.call('postMessage', 'postMessage', event);
    }
  }]);

  return AppMessage;
}(Message), (_applyDecoratedDescriptor(_class$1.prototype, "postMessage", [_dec$1], Object.getOwnPropertyDescriptor(_class$1.prototype, "postMessage"), _class$1.prototype)), _class$1));
var appPostMessage = new AppMessage();

var SmpMessage = /*#__PURE__*/function (_Message) {
  _inherits(SmpMessage, _Message);

  var _super = _createSuper(SmpMessage);

  function SmpMessage() {
    _classCallCheck$1(this, SmpMessage);

    return _super.apply(this, arguments);
  }

  _createClass$1(SmpMessage, [{
    key: "postMessage",
    value: function postMessage(event) {
      var name = event.name;
      var result = this.checkApiConfig(name, 'smp');
      if (result) return result;
      return bridge$1.call('postMessage', 'postMessage', event);
    }
  }]);

  return SmpMessage;
}(Message);

var smpPostMessage = new SmpMessage();

var WebMessage = /*#__PURE__*/function (_Message) {
  _inherits(WebMessage, _Message);

  var _super = _createSuper(WebMessage);

  function WebMessage() {
    _classCallCheck$1(this, WebMessage);

    return _super.apply(this, arguments);
  }

  _createClass$1(WebMessage, [{
    key: "postMessage",
    value: function postMessage(event) {
      var name = event.name;
      var result = this.checkApiConfig(name, 'web');
      if (result) return result;
      return bridge$3.call('postMessage', 'postMessage', event);
    }
  }]);

  return WebMessage;
}(Message);

var webPostMessage = new WebMessage();

var postMessage = channelFilter('postMessage', {
  app: appPostMessage,
  smp: smpPostMessage,
  web: webPostMessage
});

function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties(e,t){for(var o=0;o<t.length;o++){var a=t[o];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a);}}function _createClass(e,t,o){return t&&_defineProperties(e.prototype,t),o&&_defineProperties(e,o),e}function _slicedToArray(e,t){return _arrayWithHoles(e)||_iterableToArrayLimit(e,t)||_nonIterableRest()}function _arrayWithHoles(e){if(Array.isArray(e))return e}function _iterableToArrayLimit(e,t){var o=[],a=!0,i=!1,n=void 0;try{for(var r,s=e[Symbol.iterator]();!(a=(r=s.next()).done)&&(o.push(r.value),!t||o.length!==t);a=!0);}catch(e){i=!0,n=e;}finally{try{a||null==s.return||s.return();}finally{if(i)throw n}}return o}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}var ExposeMachine=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};_classCallCheck(this,e),this.exposedMap=new WeakMap,this.targetName=void 0,this.ratioName=void 0,this.observerName=void 0,this.exposeOnlyOnceName=void 0,this.dataName=void 0,this.minExposeTimeName=void 0,this.ratioRange=void 0,this.ratio=void 0,this.exposeOnlyOnce=void 0,this.minExposeTime=void 0,this.onExposed=void 0,this.onTargetAdd=void 0,this.onTargetRemoved=void 0,this.exposeMachine=null,this.mutationMachine=null;var o=t.targetName,a=void 0===o?"expose-target":o,i=t.ratioName,n=void 0===i?"expose-ratio":i,r=t.observerName,s=void 0===r?"expose-observer":r,c=t.exposeOnlyOnceName,u=void 0===c?"expose-only-once":c,d=t.dataName,l=void 0===d?"expose-data":d,h=t.minExposeTimeName,m=void 0===h?"min-expose-time":h,p=t.ratioRange,v=void 0===p?[0,.1,.2,.3,.4,.5,.6,.7,.8,.9,1]:p,f=t.ratio,y=void 0===f?0:f,g=t.exposeOnlyOnce,x=void 0!==g&&g,b=t.minExposeTime,E=void 0===b?0:b,N=t.onExposed,T=t.onTargetAdd,A=t.onTargetRemoved;this.targetName=a,this.ratioName=n,this.observerName=s,this.exposeOnlyOnceName=u,this.dataName=l,this.minExposeTimeName=m,this.ratio=y,this.exposeOnlyOnce=x,this.minExposeTime=E,this.ratioRange=v,this.onExposed=N,this.onTargetAdd=T,this.onTargetRemoved=A,this.initMachine(),this.traverseElements();}return _createClass(e,[{key:"initMachine",value:function(){var e=this;this.exposeMachine=new IntersectionObserver(function(t){t.forEach(function(t){var o=t.target,a=t.intersectionRatio,i=t.isIntersecting,n=parseFloat(e.getAttribute(o,e.ratioName))||e.ratio,r=e.getAttribute(o,e.exposeOnlyOnceName),s=null==r?e.exposeOnlyOnce:"false"!==r,c=parseFloat(e.getAttribute(o,e.minExposeTimeName))||e.minExposeTime;i&&n<=a&&e.onExposed&&void 0===e.exposedMap.get(o)&&e.exposedMap.set(o,setTimeout(function(){e.onExposed&&e.onExposed({target:o,data:e.buildData(o)}),s&&e.exposedMap.set(o,"stone");},c)),i||"number"==typeof e.exposedMap.get(o)&&(clearTimeout(e.exposedMap.get(o)),e.exposedMap.delete(o));});},{threshold:this.ratioRange}),this.mutationMachine=new MutationObserver(function(t){t.forEach(function(t){"childList"===t.type&&(t.addedNodes.forEach(function(t){1===t.nodeType&&(t.hasAttribute(e.targetName)&&e.exposeElement(t),t.querySelectorAll("[".concat(e.targetName,"]")).forEach(function(t){e.exposeElement(t);}));}),t.removedNodes.forEach(function(t){1===t.nodeType&&(t.hasAttribute(e.targetName)&&e.onTargetRemoved&&e.onTargetRemoved({target:t,data:e.buildData(t)}),t.querySelectorAll("[".concat(e.targetName,"]")).forEach(function(o){e.onTargetRemoved&&e.onTargetRemoved({target:t,data:e.buildData(t)});}));}));});});}},{key:"getAttribute",value:function(e,t){return e.getAttribute(t)}},{key:"getAttributeKeys",value:function(e){return Array.from(e.attributes).map(function(e){return e.name})}},{key:"convertAttributeName",value:function(e){return e=e.replace(/___(\w)/g,function(e,t){return t.toUpperCase()})}},{key:"buildData",value:function(e){var t=this,o=this.getAttributeKeys(e),a={};return o.forEach(function(o){var i=_slicedToArray(o.split("".concat(t.dataName,"-")),2),n=i[0],r=i[1];""===n&&r&&(a[t.convertAttributeName(r)]=t.getAttribute(e,o));}),a}},{key:"traverseElements",value:function(){var e=this,t=document.querySelectorAll("[".concat(this.targetName,"]")),o=document.querySelectorAll("[".concat(this.observerName,"]"));t.forEach(function(t){e.exposeElement(t);}),o.forEach(function(t){e.observeElement(t);});}},{key:"exposeElement",value:function(e){this.exposeMachine&&(this.onTargetAdd&&this.onTargetAdd({target:e,data:this.buildData(e)}),this.exposeMachine.observe(e));}},{key:"observeElement",value:function(e){if(this.mutationMachine){this.mutationMachine.observe(e,{childList:!0,subtree:!0});}}}]),e}();

/* 热力数据请求 */

var getHeatMapData = function getHeatMapData(data) {
  return request({
    path: "/content/tracking/data",
    method: "post",
    withToken: false,
    data: {
      req: data
    }
  }).then(function (d) {
    var data = d.data;
    var result = {};
    data.forEach(function (item) {
      var key = Object.keys(item)[0];
      result[key] = item[key];
    });
    return result;
  });
};

/* 热力值从低到高色值 */
var heatColors = ['#375093', '#4E70AF', ' #7091C7', '#9EBCDB', '#C8D7E7', '#E8EDF1', '#F0EBE7', '#E7DEB6', '#D3A480', '#B76F5B', '#95443E', '#7A2424'];

var heatbarRenderer = (function () {
  /* 热力渐变条 */
  var heatBar = document.createElement('div');
  heatBar.innerHTML = "\n    <div \n      style=\"\n        width: 100%;\n        height: 5px;\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n        border-radius: 2px;\n        overflow: hidden;\n        background-image: linear-gradient(to right, ".concat(heatColors.join(','), ");\n      \"\n    >\n    </div>\n    <div\n      style=\"\n        display: flex;\n        justify-content: space-between;\n        font-size: 16px;\n        color: #555;\n      \"\n    >\n      <span>Cold</span>\n      <span>Hot</span>\n    </div>\n  ");
  heatBar.className = 'heat-bar';
  heatBar.setAttribute('style', "\n    position: fixed;\n    width: 80%;\n    bottom: 10%;\n    left: 10%;\n    z-index: 1001;\n  ");
  document.body.appendChild(heatBar);
});

/* 弹窗 */

var popUpRenderer = (function (options) {
  var _options$title = options.title,
      title = _options$title === void 0 ? '' : _options$title,
      text = options.text,
      node = options.node,
      _options$popType = options.popType,
      popType = _options$popType === void 0 ? 'BottomIn' : _options$popType,
      _options$destroy = options.destroy,
      destroy = _options$destroy === void 0 ? true : _options$destroy;
  var hidden = true;
  var trueText = [];

  if (text instanceof Array) {
    trueText = text;
  } else if (text) {
    trueText = [text];
  } // 创建弹窗容器


  var popupContainer = document.createElement('div');
  popupContainer.style.display = 'none';
  popupContainer.style.position = 'fixed';
  popupContainer.style.top = '0';
  popupContainer.style.left = '0';
  popupContainer.style.width = '100%';
  popupContainer.style.height = '100%';
  popupContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
  popupContainer.style.zIndex = '9999';
  popupContainer.style.transition = 'opacity 0.3s ease-in-out';
  popupContainer.style.opacity = '0'; // 创建弹窗内容

  var popup = document.createElement('div');
  popup.style.backgroundColor = 'white';
  popup.style.padding = '20px';
  popup.style.boxShadow = '0 0 10px rgba(0, 0, 0, 0.2)';
  popup.style.position = 'absolute';
  popup.style.boxSizing = 'border-box';
  popup.style.transition = 'all 0.3s ease-in-out';

  if (popType === 'FadeIn') {
    popup.style.width = '90%';
    popup.style.left = '5%';
    popup.style.top = '50%';
    popup.style.transform = 'translateY(-50%)';
    popup.style.borderRadius = '5px';
  } else if (popType === 'BottomIn') {
    popup.style.width = '100%';
    popup.style.bottom = '0px';
    popup.style.borderRadius = '5px 5px 0px 0px';
    popup.style.bottom = '0px';
    popup.style.transform = 'translateY(100%)';
  }

  popup.addEventListener('click', function (e) {
    e.stopPropagation();
  }); // 创建弹窗标题

  var popupTitle = document.createElement('h2');
  popupTitle.textContent = title;
  popupTitle.style.marginTop = '0px';
  popupTitle.style.fontSize = '16px'; // 创建弹窗文本

  var popupText = document.createElement('div');
  popupText.innerHTML = trueText.map(function (text) {
    return "<p style=\"margin: 0px; padding: 0px; margin-top: 5px;\">".concat(text, "</p>");
  }).join('');
  popupText.style.marginBottom = '10px';
  popupText.style.marginTop = '0px';
  popupText.style.fontSize = '13px';
  popup.appendChild(popupTitle);
  popup.appendChild(popupText);

  if (node) {
    popup.appendChild(node);
  }

  popupContainer.appendChild(popup);
  document.body.appendChild(popupContainer);

  var show = function show() {
    if (hidden) {
      popupContainer.style.display = 'flex';

      if (destroy) {
        document.body.appendChild(popupContainer);
      }
      /* 延时，保证动画效果 */


      setTimeout(function () {
        popupContainer.style.opacity = '1';

        if (popType === 'BottomIn') {
          popup.style.transform = 'translateY(0px)';
        }
      });
      hidden = false;
    }
  };

  var hide = function hide() {
    if (!hidden) {
      popupContainer.style.opacity = '0';

      if (popType === 'BottomIn') {
        popup.style.transform = 'translateY(100%)';
      }

      if (destroy) {
        document.body.removeChild(popupContainer);
      } else {
        popupContainer.style.display = 'none';
      }

      hidden = true;
    }
  };

  popupContainer.addEventListener('click', function () {
    hide();
  });
  return {
    show: show,
    hide: hide
  };
});

var Filter = /*#__PURE__*/function (_HTMLElement) {
  _inherits(Filter, _HTMLElement);

  var _super = _createSuper(Filter);

  function Filter() {
    var _this;

    _classCallCheck$1(this, Filter);

    _this = _super.call(this);

    var shadow = _this.attachShadow({
      mode: "open"
    });

    if (_this.shadowRoot) {
      _this.shadowRoot.innerHTML = "\n        <style>\n          .wrapper {\n            width: 100%;\n            display: grid;\n            left: 10%;\n            grid-template-columns: repeat(3, 33.33%);\n            grid-row-gap: 10px;\n            font-size: 12px;\n            color: #000;\n          }\n          .item {\n            width: 100%;\n            border: 1px solid #aaa;\n            border-radius: 2px;\n            font-size: 12px;\n            color: #555;\n          }\n        </style>\n        <div class=\"wrapper\">\n          <div>\n            <div style=\"padding-bottom:2px\">Disable:</div>\n            <select id=\"disable\" class=\"item\" style=\"height: 32px;\">\n              <option value=\"false\">false</option>\n              <option value=\"true\">true</option>\n            </select>\n          </div>\n          <div style=\"padding-left: 10px;\">\n            <div style=\"padding-bottom:2px\">Start date:</div>\n            <input id=\"start-date\" class=\"item\" style=\"height: 30px;\" type=\"date\" />\n          </div>\n          <div style=\"padding-left: 10px;\">\n            <div style=\"padding-bottom:2px\">End date:</div>\n            <input id=\"end-date\" class=\"item\" style=\"height: 30px;\" type=\"date\" />\n          </div>\n          <div>\n            <div style=\"padding-bottom:2px\">Platform:</div>\n            <select id=\"platform\" class=\"item\" style=\"height: 32px;\">\n              <option value=\"current\">current</option>\n              <option value=\"iOS\">iOS</option>\n              <option value=\"ANDROID\">ANDROID</option>\n              <option value=\"WechatMiniprogram\">WechatMiniprogram</option>\n              <option value=\"PcWeb\">PcWeb</option>\n              <option value=\"MobileWeb\">MobileWeb</option>\n            </select>\n          </div>\n        </div>\n      ";
    }

    var buttonContainer = document.createElement('div');
    buttonContainer.style.textAlign = 'right';
    var button = document.createElement('button');
    buttonContainer.appendChild(button);
    button.textContent = 'Confirm';
    button.setAttribute('style', "\n      background-color: #007bff;\n      color: #fff;\n      border: none;\n      border-radius: 5px;\n      padding: 5px 10px;\n      font-size: 12px;\n      margin-top: 10px;\n    ");
    button.addEventListener('click', function () {
      var disabled = shadow.getElementById('disable').value;
      var startDate = shadow.getElementById('start-date').value;
      var endDate = shadow.getElementById('end-date').value;
      var platform = shadow.getElementById('platform').value;
      var event = new CustomEvent('confirm', {
        bubbles: true,
        composed: true,
        detail: {
          startDate: startDate,
          endDate: endDate,
          platform: platform,
          disabled: disabled
        }
      });

      _this.dispatchEvent(event);
    });
    shadow.appendChild(buttonContainer);
    return _this;
  }

  return Filter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* 已经定义过的，就不要定义了 */


if (!customElements.get('heat-map-filter')) {
  customElements.define('heat-map-filter', Filter);
}

var FilterRenderer = (function (onConfirm) {
  var filterContainer = document.createElement('div');
  filterContainer.setAttribute('style', "\n    padding-bottom: 2px;\n    position: fixed;\n    right: 0px;\n    z-index: 1002;\n    width: 40px;\n    height: 40px;\n    font-size: 35px;\n    background: #fff;\n    top: 50%;\n    right: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 20px;\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n  ");
  filterContainer.innerHTML = '⚙';
  document.body.appendChild(filterContainer);
  var filter = document.createElement('heat-map-filter');

  var _popUp = popUpRenderer({
    node: filter,
    popType: 'FadeIn',
    destroy: false,
    title: 'Filter'
  }),
      show = _popUp.show,
      hide = _popUp.hide;

  filter.addEventListener('confirm', function (e) {
    var _e$detail = e.detail,
        startDate = _e$detail.startDate,
        endDate = _e$detail.endDate,
        platform = _e$detail.platform,
        disabled = _e$detail.disabled;
    var res = {};
    if (startDate) res.startDate = startDate;
    if (endDate) res.endDate = endDate;
    if (platform) res.platform = platform;
    if (disabled) res.disabled = disabled;
    onConfirm && onConfirm(res);
    hide();
  });
  filterContainer.addEventListener('click', function () {
    show();
  });
});

/* 当前时间 */
var now = Date.now();
/* 获取2022-01-01这种格式的日期 */

var getDate = function getDate(time) {
  var date = new Date(time);
  return "".concat(date.getFullYear(), "-").concat(String(date.getMonth() + 1).padStart(2, '0'), "-").concat(String(date.getDate()).padStart(2, '0'));
};
/* 获取相反色 */


var getContrastColor = function getContrastColor(hexColor) {
  // 将颜色值转换为 RGB 格式
  var rgbColor = parseInt(hexColor.slice(1), 16);
  var r = rgbColor >> 16 & 255;
  var g = rgbColor >> 8 & 255;
  var b = rgbColor & 255; // 计算亮度值（适合判断亮度的公式）

  var brightness = (r * 299 + g * 587 + b * 114) / 1000; // 根据亮度值选择合适的字体颜色

  return brightness > 128 ? 'black' : 'white';
};
/**
 * 将>1000的数字转化为xk，保留一位小数
 * 如果>10000，不保留小数
 * 比如：1000 -> 1k
 */


var toXk = function toXk(num) {
  if (num >= 10000) {
    return "".concat((num / 1000).toFixed(0), "k");
  } else if (num > 1000) {
    return "".concat((num / 1000).toFixed(1), "k");
  }

  return num;
};
/* 将小数转化为百分比 */


var toPercent = function toPercent(num) {
  return "".concat((num * 100).toFixed(1), "%");
};
/**
 * 埋点热力图
 * 1. 热力数据获取/上报
 * 2. 热力数据展示
 * 
 * 流程
 * new element found -> create new heatDataElement -> add to render pool -> waiting & collect -> request service -> render
 * deleted element found -> remove heatDataElement -> render
 */


var HeatMap = /*#__PURE__*/function () {
  /* 热力数据 */

  /* 热力点击总数 */

  /* 热力曝光总数 */

  /* 最大点击数 */

  /* 最大曝光数 */

  /* filter */

  /* 渲染 */
  function HeatMap() {
    var _this = this;

    _classCallCheck$1(this, HeatMap);

    _defineProperty(this, "heatData", new Map());

    _defineProperty(this, "clickSum", 0);

    _defineProperty(this, "impressionSum", 0);

    _defineProperty(this, "maxClick", -Infinity);

    _defineProperty(this, "maxImpression", -Infinity);

    _defineProperty(this, "filter", {
      type: 'click',
      endDate: getDate(now),
      startDate: getDate(now - 1000 * 60 * 60 * 24 * 7),
      platform: 'current',
      disabled: 'false'
    });

    _defineProperty(this, "render", debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var _iterator, _step, element;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.filter.disabled === 'true')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return _this.requestHeatData();

            case 4:
              /* 计算辅助数 */
              _this.calculate();
              /* 渲染元素 */


              _iterator = _createForOfIteratorHelper(_this.heatData.keys());

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  element = _step.value;

                  _this.renderElement(element);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), 500));

    heatbarRenderer();
    FilterRenderer(function (filter) {
      _this.setFilter(filter);
    });
  }

  _createClass$1(HeatMap, [{
    key: "hasElement",
    value: function hasElement(element) {
      return !!this.heatData.get(element);
    }
    /* remove element heat cover */

  }, {
    key: "removeHeatCovers",
    value: function removeHeatCovers() {
      var _iterator2 = _createForOfIteratorHelper(this.heatData.keys()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _element$getElementsB;

          var element = _step2.value;
          (_element$getElementsB = element.getElementsByClassName('heat-map-cover')[0]) === null || _element$getElementsB === void 0 ? void 0 : _element$getElementsB.remove();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /* 刷新 */

  }, {
    key: "refresh",
    value: function refresh() {
      var forceRequst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.maxClick = 0;
      this.maxImpression = 0;
      this.clickSum = 0;
      this.impressionSum = 0;
      /* 重新发起请求 */

      if (forceRequst) {
        var _iterator3 = _createForOfIteratorHelper(this.heatData.keys()),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var element = _step3.value;
            var heatData = this.heatData.get(element);
            heatData.status = 'none';
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      this.render();
    }
    /* 设置filter */

  }, {
    key: "setFilter",
    value: function setFilter(filter) {
      this.filter = _objectSpread2(_objectSpread2({}, this.filter), filter);

      if (filter.disabled === 'true') {
        this.removeHeatCovers();
        return;
      }

      var needRefresh = !!(filter.startDate || filter.endDate || filter.platform);
      this.refresh(needRefresh);
    }
    /* 请求热力数据 */

  }, {
    key: "requestHeatData",
    value: function () {
      var _requestHeatData = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var _this2 = this;

        var box, _iterator4, _step4, element, heatData, key, endDate, startDate, params, response;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                /* 存储数据的box */
                box = {};
                _iterator4 = _createForOfIteratorHelper(this.heatData.keys());

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    element = _step4.value;
                    heatData = this.heatData.get(element);

                    if (heatData.status === 'none') {
                      heatData.status = 'pending';
                      key = randomString();
                      box[key] = {
                        element: element,
                        params: heatData.params
                      };
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                _context2.prev = 3;

                /* 默认7天内 */
                endDate = this.filter.endDate;
                startDate = this.filter.startDate;
                params = Object.keys(box).map(function (key) {
                  var params = box[key].params;
                  var request = {
                    key: key,
                    pageType: params.pageType_var,
                    positionType: params.objectType_var,
                    module: params.module_var,
                    startDate: startDate,
                    endDate: endDate
                  };
                  /* platform调整 */

                  if (_this2.filter.platform === 'current') {
                    request.clientPlatform = params.platform_var;
                  } else {
                    request.clientPlatform = _this2.filter.platform;
                  }
                  /* objectId和ObjectPosition不能同存 */


                  if (params.objectPosition_var) {
                    request.positionId = params.objectPosition_var;
                  } else if (params.objectId_var) {
                    request.objectId = params.objectId_var;
                  }

                  return request;
                });
                _context2.next = 9;
                return getHeatMapData(params);

              case 9:
                response = _context2.sent;

                /* 处理数据 */
                Object.keys(box).forEach(function (key) {
                  /* 该数据有问题，直接跳过 */
                  if (!response[key]) return;
                  var _response$key = response[key],
                      pv = _response$key.pv,
                      click = _response$key.click,
                      ctr = _response$key.ctr;
                  var element = box[key].element;
                  /* 调取接口成功后再修改状态 */

                  var data = _this2.heatData.get(element);

                  if (data) {
                    data.status = 'success';
                    data.click = click || 0;
                    data.impression = pv || 0;
                    data.ctr = ctr || 0;
                  }
                });
                _context2.next = 15;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](3);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 13]]);
      }));

      function requestHeatData() {
        return _requestHeatData.apply(this, arguments);
      }

      return requestHeatData;
    }()
    /* 计算辅助值 */

  }, {
    key: "calculate",
    value: function calculate() {
      this.maxClick = -Infinity;
      this.maxImpression = -Infinity;
      this.clickSum = 0;
      this.impressionSum = 0;

      var _iterator5 = _createForOfIteratorHelper(this.heatData.values()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _step5.value,
              _step5$value$click = _step5$value.click,
              click = _step5$value$click === void 0 ? 0 : _step5$value$click,
              _step5$value$impressi = _step5$value.impression,
              impression = _step5$value$impressi === void 0 ? 0 : _step5$value$impressi;
          this.clickSum += click;
          this.impressionSum += impression;

          if (click > this.maxClick) {
            this.maxClick = click;
          }

          if (impression > this.maxImpression) {
            this.maxImpression = impression;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "removeElement",
    value: function removeElement(element) {
      if (this.hasElement(element)) {
        this.heatData["delete"](element);
        this.render();
      }
    }
  }, {
    key: "addElement",
    value: function addElement(element, params) {
      if (this.hasElement(element)) return;
      this.heatData.set(element, {
        status: 'none',
        params: params,
        click: 0,
        impression: 0,
        ctr: 0
      });
      this.render();
    }
    /* 元素渲染 */

  }, {
    key: "renderElement",
    value: function renderElement(element) {
      var _computedStyleMap$get;

      var heatData = this.heatData.get(element);
      /* 避免渲染已删除元素 */

      if (!heatData) return;
      var click = heatData.click,
          impression = heatData.impression,
          status = heatData.status;
      /* 获取数据失败的不做展示 */

      if (status !== 'success') return;
      var coverClass = 'heat-map-cover';
      var coverElement = element.getElementsByClassName('heat-map-cover')[0];
      var position = (_computedStyleMap$get = element.computedStyleMap().get('position')) === null || _computedStyleMap$get === void 0 ? void 0 : _computedStyleMap$get.value;
      /* 为元素添加position */

      if (position !== 'relative' && position !== 'absolute' && position !== 'fixed') {
        element.style.position = 'relative';
      }
      /* 添加cover */


      if (!coverElement) {
        coverElement = document.createElement('div');
        coverElement.className = coverClass;
        coverElement.setAttribute('style', "\n        position: absolute;\n        left: 0px;\n        top: 0px;\n        right: 0px;\n        bottom: 0px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 16px;\n        color: #000;\n        opacity: 0.8;\n        overflow: hidden;\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n        z-index: 1000;\n      ");
        coverElement.addEventListener('click', function (e) {
          e.stopPropagation();
          popUpRenderer({
            title: 'Details',
            text: ["click: ".concat(heatData.click), "impression: ".concat(heatData.impression), "ctr: ".concat(heatData.ctr)].concat(_toConsumableArray(Object.keys(heatData.params).map(function (key) {
              if (['eventKey_var', 'eventType_var'].includes(key)) return '';
              return "".concat(key, ": ").concat(heatData.params[key]);
            })))
          }).show();
        });
        element.insertBefore(coverElement, element.firstChild);
      }
      /* 热力颜色 */


      var color = '';

      if (this.filter.type === 'click') {
        color = this.color(click / this.maxClick || 0);
      } else {
        color = this.color(impression / this.maxImpression || 0);
      }

      coverElement.style.background = color;
      /* 能够列展示 */

      var minColumnHeight = 50;
      var minColumnWidth = 50;
      /* 能够行展示 */

      var minRowHeight = 15;
      var minRowWidth = 140;
      var height = coverElement.clientHeight;
      var width = coverElement.clientWidth;
      var itemStyle = "font-size:13px;line-height:140%;padding:0px 3px; margin:0px;overflow:hidden;white-space:nowrap;font-weight:normal;color:".concat(getContrastColor(color));
      var displayHtml = '';

      if (height >= minColumnHeight && width >= minColumnWidth) {
        /* 列展示 */
        displayHtml = "\n        <div style=\"padding:0px; margin:0px\">\n          <div style=\"".concat(itemStyle, "\">\uD83D\uDC46 : ").concat(toXk(heatData.click), "</div>\n          <div style=\"").concat(itemStyle, "\">\uD83D\uDC41\uFE0F : ").concat(toXk(heatData.impression), "</div>\n          <div style=\"").concat(itemStyle, "\">\u21BB : ").concat(toPercent(heatData.ctr), "</div>\n        </div>\n      ").trim();
      } else if (height >= minRowHeight && width >= minRowWidth) {
        /* 行展示 */
        displayHtml = "\n        <div style=\"padding:0px; margin:0px;display:flex\">\n          <div style=\"".concat(itemStyle, "\">\uD83D\uDC46 : ").concat(toXk(heatData.click), "</div>\n          <div style=\"").concat(itemStyle, "\">\uD83D\uDC41\uFE0F : ").concat(toXk(heatData.impression), "</div>\n          <div style=\"").concat(itemStyle, "\">\u21BB : ").concat(toPercent(heatData.ctr), "</div>\n        </div>\n      ").trim();
      } else if (height * width >= 1900) {
        /* 简化展示 */
        displayHtml = "<div style=\"font-size:12px;line-height:140%;margin:0px;overflow:hidden;width:100%;word-break:break-word;\">".concat(toXk(heatData.click), "/").concat(toXk(heatData.impression), "/").concat(toPercent(heatData.ctr), "</div>");
      } else {
        displayHtml = '';
      }

      coverElement.innerHTML = displayHtml;
    }
    /* 取色 */

  }, {
    key: "color",
    value: function color(value) {
      if (value === 1) {
        value = 0.99;
      }

      return heatColors[Math.floor(value * 12)];
    }
  }]);

  return HeatMap;
}();

/**
 * 自动化埋点
 * 1. 保管埋点集成
 * 2. 点击埋点集成
 * 3. 埋点热力图
 * @caution auto-track需要在mount阶段实例化
 */

var AutoTrack = /*#__PURE__*/function () {
  /* 关键字命名 */

  /* 通用埋点参数配置 */

  /* 热力图 */
  function AutoTrack(options) {
    var _this = this;

    _classCallCheck$1(this, AutoTrack);

    _defineProperty(this, "targetName", 'at-target');

    _defineProperty(this, "observerName", 'at-observer');

    _defineProperty(this, "dataName", 'at-data');

    _defineProperty(this, "exposeOnlyOnceName", 'at-expose-only-once');

    _defineProperty(this, "muteClickName", 'at-mute-click');

    _defineProperty(this, "muteImpressionName", 'at-mute-impression');

    _defineProperty(this, "commonParams", {});

    _defineProperty(this, "heatMap", null);

    if (options !== null && options !== void 0 && options.autoObserver) {
      /* 默认会在body层做observer */
      document.body.setAttribute(this.observerName, 'true');
    }

    if (options !== null && options !== void 0 && options.commonParams) {
      this.commonParams = options.commonParams;
    }

    if (options !== null && options !== void 0 && options.enableHeatMap) {
      this.heatMap = new HeatMap();
    }

    new ExposeMachine({
      targetName: this.targetName,
      observerName: this.observerName,
      dataName: this.dataName,
      exposeOnlyOnceName: this.exposeOnlyOnceName,
      onExposed: function onExposed(e) {
        /* 曝光埋点 */
        if (!e.target.hasAttribute(_this.muteImpressionName)) {
          _this.track('impressionData', e.data);
        }
      },
      onTargetRemoved: function onTargetRemoved(e) {
        _this.heatMap && _this.heatMap.removeElement(e.target);
      },
      onTargetAdd: function onTargetAdd(e) {
        /* 将元素添加至热力图 */
        _this.heatMap && _this.heatMap.addElement(e.target, _this.buildParams('clickData', e.data));
        /* 点击埋点 */

        if (!e.target.hasAttribute(_this.muteClickName) && !e.target.hasAttribute('ikea-auto-track-marked-element')) {
          e.target.addEventListener('click', function () {
            _this.track('clickData', e.data);
          });
        }
        /* 将元素标记，防止重复添加 */


        e.target.setAttribute('ikea-auto-track-marked-element', 'true');
      }
    });
  }
  /**
   * 参数处理
   * 
   * eventKey_var:
   * 在impression下加 -impression
   * 在click下加 -click
   * 
   * eventKey_var_impression:
   * impression 下的 eventKey_var
   * 
   * eventKey_var_click:
   * click 下的 eventKey_var
   */


  _createClass$1(AutoTrack, [{
    key: "buildParams",
    value: function buildParams(eventName, params) {
      /* 公共参数 */
      var commonParams = {
        platform_var: getPlatform(),
        partyUID_var: getPartyUid(),
        deviceId_var: getDeviceId$1()
      };
      var eventKey_var = undefined;
      /* 动态数据解析 */

      if (params['stringify-json']) {
        try {
          params = _objectSpread2(_objectSpread2({}, params), JSON.parse(params['stringify-json']));
        } catch (_unused) {
          /* nothing to do here */
        }

        delete params['stringify-json'];
      }
      /* 点击 */


      if (eventName === 'clickData') {
        commonParams.eventType_var = 'click';

        if (params.eventKey_var_click) {
          eventKey_var = params.eventKey_var_click;
        } else if (params.eventKey_var) {
          eventKey_var = params.eventKey_var + '-click';
        }
      }
      /* 曝光 */


      if (eventName === 'impressionData') {
        commonParams.eventType_var = 'impression';

        if (params.eventKey_var_impression) {
          eventKey_var = params.eventKey_var_impression;
        } else if (params.eventKey_var) {
          eventKey_var = params.eventKey_var + '-impression';
        }
      }
      /* 删除辅助参数 */


      delete params.eventKey_var_click;
      delete params.eventKey_var_impression;
      return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, commonParams), this.commonParams), params), {}, {
        eventKey_var: eventKey_var
      });
    }
    /* 埋点 */

  }, {
    key: "track",
    value: function track(eventName, params) {
      if (params.eventKey_var) {
        var builtParams = this.buildParams(eventName, params);
        tracking.track(eventName, builtParams.eventKey_var, builtParams);
      } else {
        tracking.track(eventName, this.buildParams(eventName, params));
      }
    }
  }]);

  return AutoTrack;
}();

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

/* Public constants ==========================================================*/
/* ===========================================================================*/


//const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const Z_FIXED$1               = 4;
//const Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
const Z_BINARY              = 0;
const Z_TEXT                = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const Z_UNKNOWN$1             = 2;

/*============================================================================*/


function zero$1(buf) { let len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

const STORED_BLOCK = 0;
const STATIC_TREES = 1;
const DYN_TREES    = 2;
/* The three kinds of block type */

const MIN_MATCH$1    = 3;
const MAX_MATCH$1    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

const LENGTH_CODES$1  = 29;
/* number of length codes, not counting the special END_BLOCK code */

const LITERALS$1      = 256;
/* number of literal bytes 0..255 */

const L_CODES$1       = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */

const D_CODES$1       = 30;
/* number of distance codes */

const BL_CODES$1      = 19;
/* number of codes used to transfer the bit lengths */

const HEAP_SIZE$1     = 2 * L_CODES$1 + 1;
/* maximum heap size */

const MAX_BITS$1      = 15;
/* All codes must not exceed MAX_BITS bits */

const Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

const MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

const END_BLOCK   = 256;
/* end of block literal code */

const REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

const REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

const REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
const extra_lbits =   /* extra bits for each length code */
  new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]);

const extra_dbits =   /* extra bits for each distance code */
  new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]);

const extra_blbits =  /* extra bits for each bit length code */
  new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]);

const bl_order =
  new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

const DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const static_ltree  = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

const static_dtree  = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

const _dist_code    = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

const _length_code  = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

const base_length   = new Array(LENGTH_CODES$1);
zero$1(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

const base_dist     = new Array(D_CODES$1);
zero$1(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


let static_l_desc;
let static_d_desc;
let static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



const d_code = (dist) => {

  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
};


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
const put_short = (s, w) => {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
};


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
const send_bits = (s, value, length) => {

  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
};


const send_code = (s, c, tree) => {

  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
};


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
const bi_reverse = (code, len) => {

  let res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
};


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
const bi_flush = (s) => {

  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
};


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
const gen_bitlen = (s, desc) => {
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */

  const tree            = desc.dyn_tree;
  const max_code        = desc.max_code;
  const stree           = desc.stat_desc.static_tree;
  const has_stree       = desc.stat_desc.has_stree;
  const extra           = desc.stat_desc.extra_bits;
  const base            = desc.stat_desc.extra_base;
  const max_length      = desc.stat_desc.max_length;
  let h;              /* heap index */
  let n, m;           /* iterate over the tree elements */
  let bits;           /* bit length */
  let xbits;          /* extra bits */
  let f;              /* frequency */
  let overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Tracev((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
};


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
const gen_codes = (tree, max_code, bl_count) => {
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */

  const next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */
  let code = 0;              /* running code value */
  let bits;                  /* bit index */
  let n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS$1; bits++) {
    code = (code + bl_count[bits - 1]) << 1;
    next_code[bits] = code;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    let len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
};


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
const tr_static_init = () => {

  let n;        /* iterates over tree elements */
  let bits;     /* bit counter */
  let length;   /* length value */
  let code;     /* code value */
  let dist;     /* distance index */
  const bl_count = new Array(MAX_BITS$1 + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES$1 - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES$1; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES$1 + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES$1; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES$1, MAX_BITS$1);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES$1, MAX_BL_BITS);

  //static_init_done = true;
};


/* ===========================================================================
 * Initialize a new block.
 */
const init_block = (s) => {

  let n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES$1;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES$1;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES$1; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.sym_next = s.matches = 0;
};


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
const bi_windup = (s) =>
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
};

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
const smaller = (tree, n, m, depth) => {

  const _n2 = n * 2;
  const _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
};

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
const pqdownheap = (s, tree, k) => {
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */

  const v = s.heap[k];
  let j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
};


// inlined manually
// const SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
const compress_block = (s, ltree, dtree) => {
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */

  let dist;           /* distance of matched string */
  let lc;             /* match length or unmatched char (if dist == 0) */
  let sx = 0;         /* running index in sym_buf */
  let code;           /* the code to send */
  let extra;          /* number of extra bits to send */

  if (s.sym_next !== 0) {
    do {
      dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
      dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
      lc = s.pending_buf[s.sym_buf + sx++];
      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and sym_buf is ok: */
      //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");

    } while (sx < s.sym_next);
  }

  send_code(s, END_BLOCK, ltree);
};


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
const build_tree = (s, desc) => {
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */

  const tree     = desc.dyn_tree;
  const stree    = desc.stat_desc.static_tree;
  const has_stree = desc.stat_desc.has_stree;
  const elems    = desc.stat_desc.elems;
  let n, m;          /* iterate over heap elements */
  let max_code = -1; /* largest code with non zero frequency */
  let node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE$1;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
};


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
const scan_tree = (s, tree, max_code) => {
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */

  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
const send_tree = (s, tree, max_code) => {
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */

  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
const build_bl_tree = (s) => {

  let max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
};


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
const send_all_trees = (s, lcodes, dcodes, blcodes) => {
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */

  let rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
const detect_data_type = (s) => {
  /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  let block_mask = 0xf3ffc07f;
  let n;

  /* Check for non-textual ("block-listed") bytes. */
  for (n = 0; n <= 31; n++, block_mask >>>= 1) {
    if ((block_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("allow-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS$1; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
};


let static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
const _tr_init$1 = (s) =>
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
};


/* ===========================================================================
 * Send a stored block
 */
const _tr_stored_block$1 = (s, buf, stored_len, last) => {
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */

  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  bi_windup(s);        /* align on byte boundary */
  put_short(s, stored_len);
  put_short(s, ~stored_len);
  if (stored_len) {
    s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
  }
  s.pending += stored_len;
};


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
const _tr_align$1 = (s) => {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
};


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */
const _tr_flush_block$1 = (s, buf, stored_len, last) => {
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */

  let opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  let max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN$1) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->sym_next / 3));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block$1(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
};

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
const _tr_tally$1 = (s, dist, lc) => {
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */

  s.pending_buf[s.sym_buf + s.sym_next++] = dist;
  s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
  s.pending_buf[s.sym_buf + s.sym_next++] = lc;
  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

  return (s.sym_next === s.sym_end);
};

var _tr_init_1  = _tr_init$1;
var _tr_stored_block_1 = _tr_stored_block$1;
var _tr_flush_block_1  = _tr_flush_block$1;
var _tr_tally_1 = _tr_tally$1;
var _tr_align_1 = _tr_align$1;

var trees = {
	_tr_init: _tr_init_1,
	_tr_stored_block: _tr_stored_block_1,
	_tr_flush_block: _tr_flush_block_1,
	_tr_tally: _tr_tally_1,
	_tr_align: _tr_align_1
};

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const adler32 = (adler, buf, len, pos) => {
  let s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
};


var adler32_1 = adler32;

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
const makeTable = () => {
  let c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
};

// Create table on load. Just 255 signed longs. Not a problem.
const crcTable = new Uint32Array(makeTable());


const crc32 = (crc, buf, len, pos) => {
  const t = crcTable;
  const end = pos + len;

  crc ^= -1;

  for (let i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
};


var crc32_1 = crc32;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var messages = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var constants$1 = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  Z_MEM_ERROR:       -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees;




/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$1, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$1, Z_BLOCK,
  Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_STREAM_ERROR, Z_DATA_ERROR, Z_BUF_ERROR,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$1;

/*============================================================================*/


const MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
const MAX_WBITS = 15;
/* 32K LZ77 window */
const DEF_MEM_LEVEL = 8;


const LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
const LITERALS      = 256;
/* number of literal bytes 0..255 */
const L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
const D_CODES       = 30;
/* number of distance codes */
const BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
const HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
const MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

const MIN_MATCH = 3;
const MAX_MATCH = 258;
const MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

const PRESET_DICT = 0x20;

const INIT_STATE    =  42;    /* zlib header -> BUSY_STATE */
//#ifdef GZIP
const GZIP_STATE    =  57;    /* gzip header -> BUSY_STATE | EXTRA_STATE */
//#endif
const EXTRA_STATE   =  69;    /* gzip extra block -> NAME_STATE */
const NAME_STATE    =  73;    /* gzip file name -> COMMENT_STATE */
const COMMENT_STATE =  91;    /* gzip comment -> HCRC_STATE */
const HCRC_STATE    = 103;    /* gzip header CRC -> BUSY_STATE */
const BUSY_STATE    = 113;    /* deflate -> FINISH_STATE */
const FINISH_STATE  = 666;    /* stream complete */

const BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
const BS_BLOCK_DONE     = 2; /* block flush performed */
const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
const BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

const err = (strm, errorCode) => {
  strm.msg = messages[errorCode];
  return errorCode;
};

const rank = (f) => {
  return ((f) * 2) - ((f) > 4 ? 9 : 0);
};

const zero = (buf) => {
  let len = buf.length; while (--len >= 0) { buf[len] = 0; }
};

/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */
const slide_hash = (s) => {
  let n, m;
  let p;
  let wsize = s.w_size;

  n = s.hash_size;
  p = n;
  do {
    m = s.head[--p];
    s.head[p] = (m >= wsize ? m - wsize : 0);
  } while (--n);
  n = wsize;
//#ifndef FASTEST
  p = n;
  do {
    m = s.prev[--p];
    s.prev[p] = (m >= wsize ? m - wsize : 0);
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */
  } while (--n);
//#endif
};

/* eslint-disable new-cap */
let HASH_ZLIB = (s, prev, data) => ((prev << s.hash_shift) ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let HASH = HASH_ZLIB;


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */
const flush_pending = (strm) => {
  const s = strm.state;

  //_tr_flush_bits(s);
  let len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
  strm.next_out  += len;
  s.pending_out  += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending      -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
};


const flush_block_only = (s, last) => {
  _tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
};


const put_byte = (s, b) => {
  s.pending_buf[s.pending++] = b;
};


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
const putShortMSB = (s, b) => {

  //  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
};


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
const read_buf = (strm, buf, start, size) => {

  let len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32_1(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32_1(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
};


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
const longest_match = (s, cur_match) => {

  let chain_length = s.max_chain_length;      /* max hash chain length */
  let scan = s.strstart; /* current string */
  let match;                       /* matched string */
  let len;                           /* length of current match */
  let best_len = s.prev_length;              /* best match length so far */
  let nice_match = s.nice_match;             /* stop if match long enough */
  const limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  const _win = s.window; // shortcut

  const wmask = s.w_mask;
  const prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  const strend = s.strstart + MAX_MATCH;
  let scan_end1  = _win[scan + best_len - 1];
  let scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
};


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
const fill_window = (s) => {

  const _w_size = s.w_size;
  let n, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;
      if (s.insert > s.strstart) {
        s.insert = s.strstart;
      }
      slide_hash(s);
      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */
const deflate_stored = (s, flush) => {

  /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */
  let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;

  /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */
  let len, left, have, last = 0;
  let used = s.strm.avail_in;
  do {
    /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */
    len = 65535/* MAX_STORED */;     /* maximum deflate stored block length */
    have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
    if (s.strm.avail_out < have) {         /* need room for header */
      break;
    }
      /* maximum stored block length that will fit in avail_out: */
    have = s.strm.avail_out - have;
    left = s.strstart - s.block_start;  /* bytes left in window */
    if (len > left + s.strm.avail_in) {
      len = left + s.strm.avail_in;   /* limit len to the input */
    }
    if (len > have) {
      len = have;             /* limit len to the output */
    }

    /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */
    if (len < min_block && ((len === 0 && flush !== Z_FINISH$1) ||
                        flush === Z_NO_FLUSH$1 ||
                        len !== left + s.strm.avail_in)) {
      break;
    }

    /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */
    last = flush === Z_FINISH$1 && len === left + s.strm.avail_in ? 1 : 0;
    _tr_stored_block(s, 0, 0, last);

    /* Replace the lengths in the dummy stored block with len. */
    s.pending_buf[s.pending - 4] = len;
    s.pending_buf[s.pending - 3] = len >> 8;
    s.pending_buf[s.pending - 2] = ~len;
    s.pending_buf[s.pending - 1] = ~len >> 8;

    /* Write the stored block header bytes. */
    flush_pending(s.strm);

//#ifdef ZLIB_DEBUG
//    /* Update debugging counts for the data about to be copied. */
//    s->compressed_len += len << 3;
//    s->bits_sent += len << 3;
//#endif

    /* Copy uncompressed bytes from the window to next_out. */
    if (left) {
      if (left > len) {
        left = len;
      }
      //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
      s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
      s.strm.next_out += left;
      s.strm.avail_out -= left;
      s.strm.total_out += left;
      s.block_start += left;
      len -= left;
    }

    /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */
    if (len) {
      read_buf(s.strm, s.strm.output, s.strm.next_out, len);
      s.strm.next_out += len;
      s.strm.avail_out -= len;
      s.strm.total_out += len;
    }
  } while (last === 0);

  /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */
  used -= s.strm.avail_in;    /* number of input bytes directly copied */
  if (used) {
    /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */
    if (used >= s.w_size) {  /* supplant the previous history */
      s.matches = 2;     /* clear hash */
      //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
      s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
      s.strstart = s.w_size;
      s.insert = s.strstart;
    }
    else {
      if (s.window_size - s.strstart <= used) {
        /* Slide the window down. */
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) {
          s.matches++;   /* add a pending slide_hash() */
        }
        if (s.insert > s.strstart) {
          s.insert = s.strstart;
        }
      }
      //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
      s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
      s.strstart += used;
      s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
    }
    s.block_start = s.strstart;
  }
  if (s.high_water < s.strstart) {
    s.high_water = s.strstart;
  }

  /* If the last block was written to next_out, then done. */
  if (last) {
    return BS_FINISH_DONE;
  }

  /* If flushing and all input has been consumed, then done. */
  if (flush !== Z_NO_FLUSH$1 && flush !== Z_FINISH$1 &&
    s.strm.avail_in === 0 && s.strstart === s.block_start) {
    return BS_BLOCK_DONE;
  }

  /* Fill the window with any remaining input. */
  have = s.window_size - s.strstart;
  if (s.strm.avail_in > have && s.block_start >= s.w_size) {
    /* Slide the window down. */
    s.block_start -= s.w_size;
    s.strstart -= s.w_size;
    //zmemcpy(s->window, s->window + s->w_size, s->strstart);
    s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
    if (s.matches < 2) {
      s.matches++;       /* add a pending slide_hash() */
    }
    have += s.w_size;      /* more space now */
    if (s.insert > s.strstart) {
      s.insert = s.strstart;
    }
  }
  if (have > s.strm.avail_in) {
    have = s.strm.avail_in;
  }
  if (have) {
    read_buf(s.strm, s.window, s.strstart, have);
    s.strstart += have;
    s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
  }
  if (s.high_water < s.strstart) {
    s.high_water = s.strstart;
  }

  /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */
  have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
    /* maximum stored block length that will fit in pending: */
  have = s.pending_buf_size - have > 65535/* MAX_STORED */ ? 65535/* MAX_STORED */ : s.pending_buf_size - have;
  min_block = have > s.w_size ? s.w_size : have;
  left = s.strstart - s.block_start;
  if (left >= min_block ||
     ((left || flush === Z_FINISH$1) && flush !== Z_NO_FLUSH$1 &&
     s.strm.avail_in === 0 && left <= have)) {
    len = left > have ? have : left;
    last = flush === Z_FINISH$1 && s.strm.avail_in === 0 &&
         len === left ? 1 : 0;
    _tr_stored_block(s, s.block_start, len, last);
    s.block_start += len;
    flush_pending(s.strm);
  }

  /* We've done all we can with the available input and output. */
  return last ? BS_FINISH_STARTED : BS_NEED_MORE;
};


/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
const deflate_fast = (s, flush) => {

  let hash_head;        /* head of the hash chain */
  let bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH$1) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
const deflate_slow = (s, flush) => {

  let hash_head;          /* head of hash chain */
  let bflush;              /* set if current block must be flushed */

  let max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH$1) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
};


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
const deflate_rle = (s, flush) => {

  let bflush;            /* set if current block must be flushed */
  let prev;              /* byte at distance one to match */
  let scan, strend;      /* scan goes up to strend for length of run */

  const _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$1) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$1) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
const deflate_huff = (s, flush) => {

  let bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH$1) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$1) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {

  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
const lm_init = (s) => {

  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
};


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED$1; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new Uint16Array(HEAP_SIZE * 2);
  this.dyn_dtree  = new Uint16Array((2 * D_CODES + 1) * 2);
  this.bl_tree    = new Uint16Array((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new Uint16Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new Uint16Array(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.sym_buf = 0;        /* buffer for distances and literals/lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.sym_next = 0;      /* running index in sym_buf */
  this.sym_end = 0;       /* symbol table full when sym_next reaches this */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */
const deflateStateCheck = (strm) => {

  if (!strm) {
    return 1;
  }
  const s = strm.state;
  if (!s || s.strm !== strm || (s.status !== INIT_STATE &&
//#ifdef GZIP
                                s.status !== GZIP_STATE &&
//#endif
                                s.status !== EXTRA_STATE &&
                                s.status !== NAME_STATE &&
                                s.status !== COMMENT_STATE &&
                                s.status !== HCRC_STATE &&
                                s.status !== BUSY_STATE &&
                                s.status !== FINISH_STATE)) {
    return 1;
  }
  return 0;
};


const deflateResetKeep = (strm) => {

  if (deflateStateCheck(strm)) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  const s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status =
//#ifdef GZIP
    s.wrap === 2 ? GZIP_STATE :
//#endif
    s.wrap ? INIT_STATE : BUSY_STATE;
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = -2;
  _tr_init(s);
  return Z_OK$1;
};


const deflateReset = (strm) => {

  const ret = deflateResetKeep(strm);
  if (ret === Z_OK$1) {
    lm_init(strm.state);
  }
  return ret;
};


const deflateSetHeader = (strm, head) => {

  if (deflateStateCheck(strm) || strm.state.wrap !== 2) {
    return Z_STREAM_ERROR;
  }
  strm.state.gzhead = head;
  return Z_OK$1;
};


const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy) => {

  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  let wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION$1) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$1 ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED || (windowBits === 8 && wrap !== 1)) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  const s = new DeflateState();

  strm.state = s;
  s.strm = strm;
  s.status = INIT_STATE;     /* to pass state test in deflateReset() */

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new Uint8Array(s.w_size * 2);
  s.head = new Uint16Array(s.hash_size);
  s.prev = new Uint16Array(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */

  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new Uint8Array(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->sym_buf = s->pending_buf + s->lit_bufsize;
  s.sym_buf = s.lit_bufsize;

  //s->sym_end = (s->lit_bufsize - 1) * 3;
  s.sym_end = (s.lit_bufsize - 1) * 3;
  /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
};

const deflateInit = (strm, level) => {

  return deflateInit2(strm, level, Z_DEFLATED$1, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
};


/* ========================================================================= */
const deflate$1 = (strm, flush) => {

  if (deflateStateCheck(strm) || flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  const s = strm.state;

  if (!strm.output ||
      (strm.avail_in !== 0 && !strm.input) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH$1)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  const old_flush = s.last_flush;
  s.last_flush = flush;

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK$1;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH$1) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Write the header */
  if (s.status === INIT_STATE && s.wrap === 0) {
    s.status = BUSY_STATE;
  }
  if (s.status === INIT_STATE) {
    /* zlib header */
    let header = (Z_DEFLATED$1 + ((s.w_bits - 8) << 4)) << 8;
    let level_flags = -1;

    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
      level_flags = 0;
    } else if (s.level < 6) {
      level_flags = 1;
    } else if (s.level === 6) {
      level_flags = 2;
    } else {
      level_flags = 3;
    }
    header |= (level_flags << 6);
    if (s.strstart !== 0) { header |= PRESET_DICT; }
    header += 31 - (header % 31);

    putShortMSB(s, header);

    /* Save the adler32 of the preset dictionary: */
    if (s.strstart !== 0) {
      putShortMSB(s, strm.adler >>> 16);
      putShortMSB(s, strm.adler & 0xffff);
    }
    strm.adler = 1; // adler32(0L, Z_NULL, 0);
    s.status = BUSY_STATE;

    /* Compression must start with an empty pending buffer */
    flush_pending(strm);
    if (s.pending !== 0) {
      s.last_flush = -1;
      return Z_OK$1;
    }
  }
//#ifdef GZIP
  if (s.status === GZIP_STATE) {
    /* gzip header */
    strm.adler = 0;  //crc32(0L, Z_NULL, 0);
    put_byte(s, 31);
    put_byte(s, 139);
    put_byte(s, 8);
    if (!s.gzhead) { // s->gzhead == Z_NULL
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, s.level === 9 ? 2 :
                  (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                   4 : 0));
      put_byte(s, OS_CODE);
      s.status = BUSY_STATE;

      /* Compression must start with an empty pending buffer */
      flush_pending(strm);
      if (s.pending !== 0) {
        s.last_flush = -1;
        return Z_OK$1;
      }
    }
    else {
      put_byte(s, (s.gzhead.text ? 1 : 0) +
                  (s.gzhead.hcrc ? 2 : 0) +
                  (!s.gzhead.extra ? 0 : 4) +
                  (!s.gzhead.name ? 0 : 8) +
                  (!s.gzhead.comment ? 0 : 16)
      );
      put_byte(s, s.gzhead.time & 0xff);
      put_byte(s, (s.gzhead.time >> 8) & 0xff);
      put_byte(s, (s.gzhead.time >> 16) & 0xff);
      put_byte(s, (s.gzhead.time >> 24) & 0xff);
      put_byte(s, s.level === 9 ? 2 :
                  (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                   4 : 0));
      put_byte(s, s.gzhead.os & 0xff);
      if (s.gzhead.extra && s.gzhead.extra.length) {
        put_byte(s, s.gzhead.extra.length & 0xff);
        put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
      }
      if (s.gzhead.hcrc) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
      }
      s.gzindex = 0;
      s.status = EXTRA_STATE;
    }
  }
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
      while (s.pending + left > s.pending_buf_size) {
        let copy = s.pending_buf_size - s.pending;
        // zmemcpy(s.pending_buf + s.pending,
        //    s.gzhead.extra + s.gzindex, copy);
        s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
        s.pending = s.pending_buf_size;
        //--- HCRC_UPDATE(beg) ---//
        if (s.gzhead.hcrc && s.pending > beg) {
          strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        }
        //---//
        s.gzindex += copy;
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$1;
        }
        beg = 0;
        left -= copy;
      }
      // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
      //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
      let gzhead_extra = new Uint8Array(s.gzhead.extra);
      // zmemcpy(s->pending_buf + s->pending,
      //     s->gzhead->extra + s->gzindex, left);
      s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
      s.pending += left;
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
      s.gzindex = 0;
    }
    s.status = NAME_STATE;
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let val;
      do {
        if (s.pending === s.pending_buf_size) {
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$1;
          }
          beg = 0;
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
      s.gzindex = 0;
    }
    s.status = COMMENT_STATE;
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let val;
      do {
        if (s.pending === s.pending_buf_size) {
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$1;
          }
          beg = 0;
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
    }
    s.status = HCRC_STATE;
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$1;
        }
      }
      put_byte(s, strm.adler & 0xff);
      put_byte(s, (strm.adler >> 8) & 0xff);
      strm.adler = 0; //crc32(0L, Z_NULL, 0);
    }
    s.status = BUSY_STATE;

    /* Compression must start with an empty pending buffer */
    flush_pending(strm);
    if (s.pending !== 0) {
      s.last_flush = -1;
      return Z_OK$1;
    }
  }
//#endif

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH$1 && s.status !== FINISH_STATE)) {
    let bstate = s.level === 0 ? deflate_stored(s, flush) :
                 s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) :
                 s.strategy === Z_RLE ? deflate_rle(s, flush) :
                 configuration_table[s.level].func(s, flush);

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK$1;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        _tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        _tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH$1) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK$1;
      }
    }
  }

  if (flush !== Z_FINISH$1) { return Z_OK$1; }
  if (s.wrap <= 0) { return Z_STREAM_END$1; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK$1 : Z_STREAM_END$1;
};


const deflateEnd = (strm) => {

  if (deflateStateCheck(strm)) {
    return Z_STREAM_ERROR;
  }

  const status = strm.state.status;

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK$1;
};


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
const deflateSetDictionary = (strm, dictionary) => {

  let dictLength = dictionary.length;

  if (deflateStateCheck(strm)) {
    return Z_STREAM_ERROR;
  }

  const s = strm.state;
  const wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    let tmpDict = new Uint8Array(s.w_size);
    tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  const avail = strm.avail_in;
  const next = strm.next_in;
  const input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    let str = s.strstart;
    let n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK$1;
};


var deflateInit_1 = deflateInit;
var deflateInit2_1 = deflateInit2;
var deflateReset_1 = deflateReset;
var deflateResetKeep_1 = deflateResetKeep;
var deflateSetHeader_1 = deflateSetHeader;
var deflate_2$1 = deflate$1;
var deflateEnd_1 = deflateEnd;
var deflateSetDictionary_1 = deflateSetDictionary;
var deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/

var deflate_1$1 = {
	deflateInit: deflateInit_1,
	deflateInit2: deflateInit2_1,
	deflateReset: deflateReset_1,
	deflateResetKeep: deflateResetKeep_1,
	deflateSetHeader: deflateSetHeader_1,
	deflate: deflate_2$1,
	deflateEnd: deflateEnd_1,
	deflateSetDictionary: deflateSetDictionary_1,
	deflateInfo: deflateInfo
};

const _has = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

var assign = function (obj /*from1, from2, from3, ...*/) {
  const sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    const source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (const p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// Join array of chunks to single array.
var flattenChunks = (chunks) => {
  // calculate data length
  let len = 0;

  for (let i = 0, l = chunks.length; i < l; i++) {
    len += chunks[i].length;
  }

  // join chunks
  const result = new Uint8Array(len);

  for (let i = 0, pos = 0, l = chunks.length; i < l; i++) {
    let chunk = chunks[i];
    result.set(chunk, pos);
    pos += chunk.length;
  }

  return result;
};

var common = {
	assign: assign,
	flattenChunks: flattenChunks
};

// String encode/decode helpers


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const _utf8len = new Uint8Array(256);
for (let q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
var string2buf = (str) => {
  if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
    return new TextEncoder().encode(str);
  }

  let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new Uint8Array(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper
const buf2binstring = (buf, len) => {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if (buf.subarray && STR_APPLY_UIA_OK) {
      return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
  }

  let result = '';
  for (let i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
};


// convert array to string
var buf2string = (buf, max) => {
  const len = max || buf.length;

  if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) {
    return new TextDecoder().decode(buf.subarray(0, max));
  }

  let i, out;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  const utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    let c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    let c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = (buf, max) => {

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  let pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

var strings = {
	string2buf: string2buf,
	buf2string: buf2string,
	utf8border: utf8border
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

var zstream = ZStream;

const toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH,
  Z_OK, Z_STREAM_END,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED
} = constants$1;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  this.options = common.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, options || {});

  let opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new zstream();
  this.strm.avail_out = 0;

  let status = deflate_1$1.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(messages[status]);
  }

  if (opt.header) {
    deflate_1$1.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    let dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = deflate_1$1.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(messages[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  let status, _flush_mode;

  if (this.ended) { return false; }

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    // Make sure avail_out > 6 to avoid repeating markers
    if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH) && strm.avail_out <= 6) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    status = deflate_1$1.deflate(strm, _flush_mode);

    // Ended => flush and finish
    if (status === Z_STREAM_END) {
      if (strm.next_out > 0) {
        this.onData(strm.output.subarray(0, strm.next_out));
      }
      status = deflate_1$1.deflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return status === Z_OK;
    }

    // Flush if out buffer full
    if (strm.avail_out === 0) {
      this.onData(strm.output);
      continue;
    }

    // Flush if requested and has data
    if (_flush_mode > 0 && strm.next_out > 0) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    this.result = common.flattenChunks(this.chunks);
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  const deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || messages[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


var Deflate_1 = Deflate;
var deflate_2 = deflate;
var deflateRaw_1 = deflateRaw;
var gzip_1 = gzip;
var constants = constants$1;

var deflate_1 = {
	Deflate: Deflate_1,
	deflate: deflate_2,
	deflateRaw: deflateRaw_1,
	gzip: gzip_1,
	constants: constants
};

/* 用户信息设置 */
var setUser = function setUser() {
  var userId = getPartyUid();
  var deviceId = getDeviceId$1();
  /* 存在用户信息，再去setUser */

  if (userId) {
    return request({
      method: 'POST',
      withToken: false,
      path: '/event-tracking-service/api/v1/user',
      headers: {
        'X-App-Secret': getClickhouseKey()
      },
      data: {
        deviceId: deviceId,
        loginUserId: userId
      }
    })["catch"](function () {
      console.error('clickHouse: set user failed');
    });
  }

  return Promise.resolve();
};
/* 发送信息 */

var report = function report(events) {
  var strData = JSON.stringify(events);
  var utf8Data = decodeURIComponent(strData);
  var geoJsonGz = deflate_1.gzip(utf8Data);
  var gzippedBlob = new Blob([geoJsonGz]);
  var formData = new FormData();
  formData.append('data', gzippedBlob);
  return request({
    method: 'POST',
    path: '/event-tracking-service/api/v1/user-events/zipped',
    body: formData,
    headers: {
      'content-type': undefined,
      'Content-Encoding': 'gzip',
      'X-App-Secret': getClickhouseKey()
    }
  });
};

var uuid = (function () {
  var s = [];
  var hexDigits = "0123456789abcdef";

  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }

  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010

  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("").replace("-", "");
  return uuid;
});

/* clickHouse */
var ClickHouseTrack = /*#__PURE__*/function () {
  /* userProperties目前就是abtest数据 */

  /* 埋点队列 */
  function ClickHouseTrack() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$1(this, ClickHouseTrack);

    _defineProperty(this, "maxCount", void 0);

    _defineProperty(this, "countThreshold", void 0);

    _defineProperty(this, "intervalSeconds", void 0);

    _defineProperty(this, "sessionId", uuid());

    _defineProperty(this, "userProperties", request({
      path: '/configs/abtest',
      method: 'GET',
      withToken: false
    }).then(function (response) {
      return response.data;
    })["catch"](function () {
      return {};
    }));

    _defineProperty(this, "eventQueue", []);

    var _options$maxCount = options.maxCount,
        maxCount = _options$maxCount === void 0 ? 1000 : _options$maxCount,
        _options$countThresho = options.countThreshold,
        countThreshold = _options$countThresho === void 0 ? 50 : _options$countThresho,
        _options$intervalSeco = options.intervalSeconds,
        intervalSeconds = _options$intervalSeco === void 0 ? 10 : _options$intervalSeco;
    this.maxCount = maxCount;
    this.countThreshold = countThreshold;
    this.intervalSeconds = intervalSeconds;
    setInterval(this.flush.bind(this), this.intervalSeconds * 1000);
  }

  _createClass$1(ClickHouseTrack, [{
    key: "setUser",
    value: function setUser$1() {
      setUser();
    }
  }, {
    key: "persistUserEvents",
    value: function persistUserEvents() {
      /* 埋点数量太多需要清空，避免影响性能 */
      if (this.eventQueue.length > this.maxCount) {
        this.eventQueue = [];
        return;
      }
    }
    /* 发送埋点 */

  }, {
    key: "flush",
    value: function flush() {
      var _this = this;

      var eventsToReport = this.eventQueue.splice(0, this.countThreshold);
      if (eventsToReport.length === 0) return;
      report(eventsToReport).then(function (res) {
        var _this$eventQueue;

        if (res.status === 200) {
          console.log('tracking@report events success:', eventsToReport.length, eventsToReport);

          _this.persistUserEvents();

          return;
        }
        /* 失败的埋点需要重回队列 */


        (_this$eventQueue = _this.eventQueue).unshift.apply(_this$eventQueue, _toConsumableArray(eventsToReport));

        _this.persistUserEvents();
      })["catch"](function () {
        var _this$eventQueue2;

        /* 失败的埋点需要重回队列 */
        (_this$eventQueue2 = _this.eventQueue).unshift.apply(_this$eventQueue2, _toConsumableArray(eventsToReport));

        _this.persistUserEvents();
      });
    }
    /* 将事件推入队列 */

  }, {
    key: "track",
    value: function track(eventName) {
      var _this2 = this;

      var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var eventKey = arguments.length > 2 ? arguments[2] : undefined;
      var deviceId = getDeviceId$1();
      /* 没有deviceId属于无效数据 */

      if (deviceId === 'unknown') return;
      var systemProperties = {
        platform: getPlatform(),
        version: getClientVersion()
      };
      this.userProperties.then(function (userProperties) {
        _this2.eventQueue.push({
          eventId: uuid(),
          eventKey: eventKey || eventProperties.eventKey_var || '',
          eventName: eventName,
          eventProperties: eventProperties,
          systemProperties: systemProperties,
          userProperties: userProperties,
          deviceId: deviceId,
          sessionId: _this2.sessionId,
          loginUserId: getPartyUid(),
          eventTime: formatTime(new Date().getTime(), 'Y-M-D h:m:s')
        });

        if (_this2.eventQueue.length >= _this2.countThreshold) {
          _this2.flush();
        }
      });
    }
  }]);

  return ClickHouseTrack;
}();

/* gio加载 */

var gioLoaded = function gioLoaded(type) {
  if (fakeWindow.gio) return Promise.resolve();
  if (type === 'smp') return loadJS(gioLinkMaping.miniprogram);
  return loadJS(gioLinkMaping.h5);
};

var Tracking = /*#__PURE__*/function () {
  function Tracking() {
    _classCallCheck$1(this, Tracking);

    _defineProperty(this, "projectId", null);

    _defineProperty(this, "inited", null);

    _defineProperty(this, "autoTrackInstance", null);

    _defineProperty(this, "clickHouseTrack", null);

    _defineProperty(this, "gioFunctionMapping", {
      web: {
        'page.set': 'page.set',
        'evar.set': 'evar.set',
        'visitor.set': 'visitor.set',
        'people.set': 'people.set'
      },
      smp: {
        'page.set': 'setPage',
        'evar.set': 'setEvar',
        'visitor.set': 'setVisitor',
        'people.set': 'setUser'
      },
      app: {
        'page.set': 'setPage',
        'evar.set': 'setEvar',
        'visitor.set': 'setVisitor',
        'people.set': 'setUser'
      }
    });
  }

  _createClass$1(Tracking, [{
    key: "defaultInit",
    value:
    /**
     * @description 默认的初始化配置
     * @param type channel
     * @param options.projectId 工程id
     * @param options.useNative 是否使用默认的埋点
     * @param options.useLocalCollect 是否开启本地信息采集，默认true
     * @param options.useClickHouse 是否开启clickHouse
     * @param options.gioOptions gio的相关配置，直接透传
     */
    function defaultInit(type) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      /* 不会初始化多次 */
      if (this.inited) return fail('tracking.init', 'can not init for multi times');

      if (options && options.useLocalCollect === false) {
        fakeWindow._gr_ignore_local_rule = false;
      } else {
        fakeWindow._gr_ignore_local_rule = true;
      }

      if (options && options.useNative === true) {
        switch (type) {
          case 'smp':
            this.projectId = gioConfig.smp.projectId;
            break;

          case 'web':
            this.projectId = gioConfig.web.projectId;
        }
      } else {
        this.projectId = gioConfig.universal.projectId;
      }

      if (options && options.projectId) {
        this.projectId = options.projectId;
      }

      if (options && options.useClickHouse === true) {
        this.clickHouseTrack = new ClickHouseTrack();
      }

      var _getPromise = getPromise(),
          promise = _getPromise.promise,
          res = _getPromise.res;
      /**
       * 到这一步，projectId存在两种情况
       * 1. 存在，走h5的gio
       * 2. 不存在，走app的bridge 
       */


      if (this.projectId) {
        var _this$clickHouseTrack;

        gioLoaded(type).then(function () {
          if (type === 'smp') {
            fakeWindow.gio('init', _this.projectId, gioConfig.smp.appId[getChannel()] || '', options.gioOptions || {});
          } else {
            fakeWindow.gio('init', _this.projectId, options.gioOptions || {});
          }

          fakeWindow.gio('config', {
            'hashtag': true
          });
          fakeWindow.gio('send');
          var partyUid = getPartyUid();

          if (partyUid) {
            fakeWindow.gio('setUserId', partyUid);
          }

          res();
        });
        (_this$clickHouseTrack = this.clickHouseTrack) === null || _this$clickHouseTrack === void 0 ? void 0 : _this$clickHouseTrack.setUser();
      } else {
        res();
      }

      this.inited = promise;
    }
    /**
     * @description 实际的初始化配置
     * @param options.projectId 工程id
     * @param options.useNative 是否使用默认的埋点
     * @param options.useLocalCollect 是否开启本地信息采集，默认true
     * @param options.gioOptions gio的相关配置，直接透传
     */

  }, {
    key: "defaultTrack",
    value:
    /**
     * @description 默认的埋点，走h5的gio
     * @param name 事件名
     * @param params 事件参数
     */
    function defaultTrack(name, params, eventKey) {
      var _this2 = this;

      if (!this.inited) {
        return fail('tracking.track', 'please run tracking.init first');
      }

      if (!params) params = {};
      if (eventKey) params.eventKey_var = eventKey;
      return this.inited.then(function () {
        var _this2$clickHouseTrac;

        /* 发送gio */
        fakeWindow.gio('track', name, params);
        /* 发送clickHouse */

        (_this2$clickHouseTrac = _this2.clickHouseTrack) === null || _this2$clickHouseTrac === void 0 ? void 0 : _this2$clickHouseTrac.track(name, params, eventKey);
      }).then(function () {
        return apiInvokeSuccess('tracking.track');
      });
    }
    /**
     * @description 实际埋点
     * @param name 事件名
     * @param params 事件参数
     */

  }, {
    key: "getTrackFnParams",
    value:
    /**
     * @description 获取track的重载参数
     */
    function getTrackFnParams() {
      var flag = arguments.length <= 1 ? undefined : arguments[1];
      var result = {
        name: arguments.length <= 0 ? undefined : arguments[0]
      };

      if (_typeof(flag) === 'object') {
        result.params = flag;
      } else {
        result.params = arguments.length <= 2 ? undefined : arguments[2];
        result.eventKey = flag;
      }

      return result;
    }
    /** 
     * @description 默认的初始化配置
     */

  }, {
    key: "defaultGio",
    value: function defaultGio(type, name, params) {
      var _this3 = this;

      if (!this.inited) {
        return fail('tracking.gio', 'please run tracking.init first');
      }

      return this.inited.then(function () {
        fakeWindow.gio(_this3.gioFunctionMapping[type][name], params);
      }).then(function () {
        return apiInvokeSuccess('tracking.gio');
      });
    }
    /**
     * @description 底层埋点方法
     * @param name 方法名
     * @param param 方法参数
     */

  }, {
    key: "autoTrack",
    value: function autoTrack(options) {
      if (!this.autoTrackInstance) {
        this.autoTrackInstance = new AutoTrack(options);
      } else {
        console.warn('autoTrack has been loaded');
      }

      return this.autoTrackInstance;
    }
  }]);

  return Tracking;
}();

var _dec, _dec2, _class;
var AppTracking = (_dec = version$1('>=2.0.0', 'app', 'tracking.track in native'), _dec2 = version$1('>=10.0.0', 'app', 'tracking.gio in native'), (_class = /*#__PURE__*/function (_Tracking) {
  _inherits(AppTracking, _Tracking);

  var _super = _createSuper(AppTracking);

  function AppTracking() {
    _classCallCheck$1(this, AppTracking);

    return _super.apply(this, arguments);
  }

  _createClass$1(AppTracking, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.defaultInit('app', options);
      return apiInvokeSuccess('tracking.init');
    }
  }, {
    key: "track",
    value: function track() {
      var _this$getTrackFnParam = this.getTrackFnParams.apply(this, arguments),
          name = _this$getTrackFnParam.name,
          params = _this$getTrackFnParam.params,
          eventKey = _this$getTrackFnParam.eventKey;
      /* 存在projectId，走h5 gio */


      if (this.projectId) {
        return this.defaultTrack(name, params, eventKey);
      }

      return this.nativeTrack(name, params, eventKey);
    }
  }, {
    key: "nativeTrack",
    value: function nativeTrack(name, params, eventKey) {
      return bridge$4.call('tracking.track', 'onTrackEvent', {
        event: name,
        eventKey: eventKey,
        params: params
      });
    }
    /* App暂不支持 */

  }, {
    key: "gio",
    value: function gio(name, params) {
      /* 存在projectId，走h5 gio */
      if (this.projectId) {
        return this.defaultGio('web', name, params);
      }

      return bridge$4.call('tracking.gio', 'runGioFunction', {
        functionName: this.gioFunctionMapping.app[name],
        params: params
      });
    }
  }]);

  return AppTracking;
}(Tracking), (_applyDecoratedDescriptor(_class.prototype, "nativeTrack", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "nativeTrack"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gio", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "gio"), _class.prototype)), _class));
var appTracking = new AppTracking();

var SmpTracking = /*#__PURE__*/function (_Tracking) {
  _inherits(SmpTracking, _Tracking);

  var _super = _createSuper(SmpTracking);

  function SmpTracking() {
    _classCallCheck$1(this, SmpTracking);

    return _super.apply(this, arguments);
  }

  _createClass$1(SmpTracking, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.defaultInit('smp', options);
      return apiInvokeSuccess('tracking.init');
    }
  }, {
    key: "track",
    value: function track() {
      var _this$getTrackFnParam = this.getTrackFnParams.apply(this, arguments),
          name = _this$getTrackFnParam.name,
          params = _this$getTrackFnParam.params,
          eventKey = _this$getTrackFnParam.eventKey;

      return this.defaultTrack(name, params, eventKey);
    }
  }, {
    key: "gio",
    value: function gio(name, params) {
      return this.defaultGio('smp', name, params);
    }
  }]);

  return SmpTracking;
}(Tracking);

var smpTracking = new SmpTracking();

var WebTracking = /*#__PURE__*/function (_Tracking) {
  _inherits(WebTracking, _Tracking);

  var _super = _createSuper(WebTracking);

  function WebTracking() {
    _classCallCheck$1(this, WebTracking);

    return _super.apply(this, arguments);
  }

  _createClass$1(WebTracking, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.defaultInit('web', options);
      return apiInvokeSuccess('tracking.init');
    }
  }, {
    key: "track",
    value: function track() {
      var _this$getTrackFnParam = this.getTrackFnParams.apply(this, arguments),
          name = _this$getTrackFnParam.name,
          params = _this$getTrackFnParam.params,
          eventKey = _this$getTrackFnParam.eventKey;

      return this.defaultTrack(name, params, eventKey);
    }
  }, {
    key: "gio",
    value: function gio(name, params) {
      return this.defaultGio('web', name, params);
    }
  }]);

  return WebTracking;
}(Tracking);

var webTracking = new WebTracking();

var tracking = channelFilter('tracking', {
  app: appTracking,
  smp: smpTracking,
  web: webTracking
});

/**
 * @description 获取abtest信息
 */

var getVariation = function getVariation(options) {
  var experimentId = options.experimentId,
      defaultVariation = options.defaultVariation;
  return request({
    path: '/configs/abtest',
    method: 'GET',
    withToken: false
  }).then(function (response) {
    var variations = response.data;
    return apiInvokeSuccess('abtest.getVariation', variations[experimentId] || defaultVariation);
  })["catch"](function () {
    return apiInvokeSuccess('abtest.getVariation', defaultVariation);
  });
};
/**
 * @description 获取abtest list
 */


var getAbtestList = function getAbtestList() {
  return request({
    path: '/configs/abtest',
    method: 'GET',
    withToken: false
  }).then(function (response) {
    return apiInvokeSuccess('abtest.getVariation', response.data);
  })["catch"](function () {
    return fail('abtest.getVariation', 'fail to get abtest');
  });
};

var abtest = {
  getVariation: getVariation,
  getAbtestList: getAbtestList
};

var name = "ikea-jssdk";
var version = "1.34.22";
var description = "ikea jssdk";
var main = "dist/ikea-jssdk.universal.cjs.js";
var module = "dist/ikea-jssdk.universal.esm.js";
var sideEffects = false;
var types = "src/dist.d.ts";
var scripts = {
	prepublishOnly: "npm run build:esm && npm run build:cjs",
	clean: "rimraf ./dist",
	test: "npm run lint && cross-env NODE_ENV=test nyc mocha",
	release: "npm test && npm run build && git commit -am $npm_package_version && git tag $npm_package_version && git push && git push --tags",
	"build:esm": "rollup -c config/rollup.config.esm.js",
	"build:cjs": "rollup -c config/rollup.config.cjs.js",
	"build:umd": "rollup -c config/rollup.config.umd.js",
	dev: "rollup -w -c config/rollup.config.dev.js",
	deploy: "npm run build:umd && npm run deploy:res",
	"deploy:res": "ikea deploy"
};
var author = "Luka";
var license = "MIT";
var repository = {
	type: "git",
	url: "git://github.com/cikli/cn-ikeaapp-js-sdk.git"
};
var bugs = {
	url: "https://github.com/cikli/cn-ikeaapp-js-sdk/issues"
};
var files = [
	"/dist",
	"/src",
	"/scripts",
	"/plugins",
	"tsconfig.json",
	"/config"
];
var engines = {
	node: ">= 0.12.0"
};
var devDependencies = {
	"@babel/cli": "7.1.5",
	"@babel/core": "^7.1.2",
	"@babel/plugin-proposal-class-properties": "^7.13.0",
	"@babel/plugin-proposal-decorators": "^7.13.15",
	"@babel/plugin-transform-runtime": "^7.1.0",
	"@babel/preset-env": "^7.1.0",
	"@babel/preset-typescript": "^7.13.0",
	"@babel/register": "7.0.0",
	"@js-lib/cli": "^1.6.0",
	"@rollup/plugin-commonjs": "^18.0.0",
	"@rollup/plugin-html": "^0.2.3",
	"@rollup/plugin-json": "^6.0.1",
	axios: "^1.7.2",
	"babel-eslint": "^10.1.0",
	"babel-plugin-istanbul": "5.1.0",
	coveralls: "3.0.2",
	"cross-env": "5.2.0",
	"es5-shim": "4.5.10",
	eslint: "^5.15.1",
	"expect.js": "0.3.1",
	"ikea-jssdk-cli": "^1.0.15",
	mocha: "3.5.3",
	nyc: "13.1.0",
	rollup: "^2.30.0",
	"rollup-plugin-babel": "^4.0.3",
	"rollup-plugin-clear": "^2.0.7",
	"rollup-plugin-node-resolve": "3.0.3",
	"rollup-plugin-serve": "^1.1.0",
	"rollup-plugin-terser": "^7.0.2",
	"rollup-plugin-visualizer": "^5.12.0",
	"source-map-support": "0.5.9",
	typescript: "^4.2.4"
};
var dependencies = {
	"@babel/runtime": "^7.1.2",
	"expose-machine": "^2.0.5",
	pako: "^2.1.0",
	"schema-utils": "^3.0.0",
	semver: "^5.7.1"
};
var peerDependencies = {
	axios: "*"
};
var pkg = {
	name: name,
	version: version,
	description: description,
	main: main,
	module: module,
	sideEffects: sideEffects,
	types: types,
	scripts: scripts,
	author: author,
	license: license,
	repository: repository,
	bugs: bugs,
	files: files,
	engines: engines,
	devDependencies: devDependencies,
	dependencies: dependencies,
	peerDependencies: peerDependencies
};

/**
 * 对导出的sdk做后期处理
 * 1. 挂载全局对象
 * 2. 判断是否重复加载
 */

var sdkPostProcess = (function (ikea) {
  if (fakeWindow.__ikea_jssdk__) {
    console.error('multiple ikea-jssdk loaded!!!');
  } else {
    /* 全局赋值 */
    fakeWindow.__ikea_jssdk__ = ikea;
    fakeWindow.__ikea_jssdk__.version = pkg.version;
  }
});

var ikea = {
  getUserInfo: getUserInfo,
  getAddressInfo: getAddressInfo,
  getLocation: getLocation,
  getWebviewAgent: getWebviewAgent,
  navigateTo: router.navigateTo.bind(router),
  routerDelegate: router.delegate.bind(router),
  redirectTo: router.redirectTo.bind(router),
  newTabTo: router.newTabTo.bind(router),
  redirectH5: router.redirectH5.bind(router),
  newTabH5: router.newTabH5.bind(router),
  canNavigateTo: router.canNavigateTo.bind(router),
  navigateBack: router.navigateBack.bind(router),
  goToPayment: router.goToPayment.bind(router),
  goToShare: router.goToShare.bind(router),
  openH5: router.openH5.bind(router),
  currentPlatform: getCurrentPlatform,
  init: init,
  getToken: getToken,
  isLogin: isLogin,
  request: request,
  addNavigationActions: addNavigationActions,
  postMessage: postMessage.postMessage.bind(postMessage),
  tracking: tracking,
  openMap: openMap,
  generateLink: generateLink,
  bridge: bridge,
  currentLanguage: currentLanguage,
  abtest: abtest,
  goToAppStore: goToAppStore,
  checkVersion: checkVersion,
  getClientVersion: getClientVersion,
  invokeWxsdk: invokeWxsdk,
  wxJssdkLoaded: loadWxJssdk,
  getDeviceId: getDeviceId,
  getDeviceModel: getDeviceModel,
  getOsVersion: getOsVersion,
  getZipcode: getZipcode,
  getNotificationPermission: getNotificationPermission,
  openSetting: openSetting,
  openLoading: openLoading,
  closeLoading: closeLoading,
  getSessionId: getSessionId,
  scanCode: scanCode,
  initWxJssdk: initWxJssdk,
  getSharePrefereceData: getSharePrefereceData
};
sdkPostProcess(ikea);

export { ikea as default };
